export const locale = {
  general_menu_settings: 'Paramètres généraux du menu',
  settings: {
  business_type_title: 'Sélectionnez le type d\'entreprise du menu',
  currency_label: 'Devise',
  show_filter: 'Afficher le filtre des produits',
  show_categories: 'Afficher les catégories de produits',
  
  business_types: {
    cafe: 'Café',
    restaurant: 'Restaurant',
    fastfood: 'Restauration rapide',
    icecream: 'Jus et Crème glacée',
    sweets: 'Bonbons et Desserts',
    bakery: 'Boulangerie'
  },
  
  custom_labels: {
        ph_menu_cafe: 'Menu du Café',
    ph_menu_restaurant: 'Menu',
    ph_menu_fastfood: 'Menu Fast-Food',
    ph_menu_icecream: 'Jus et Glaces',
    ph_menu_sweets: 'Gâteaux et Sucreries',
    ph_menu_bakery: 'Pains et Boulangerie',
    ph_product_list: 'Produits',
    ph_add_order: 'Ajouter',
    ph_add_cart: 'Acheter',
    title: 'Personnaliser les étiquettes (Optionnel)',
    subtitle: 'Remplacez les termes système par défaut par vos propres mots.',
    products_title: 'Titre de la section des produits',
    ph_food_menu: 'ex. Menu',
    ph_product_list: 'ex. Liste de produits',
    cart_btn: 'Texte du bouton de commande',
    ph_add_order: 'ex. Ajouter à la commande',
    ph_add_cart: 'ex. Ajouter au panier'
  },

  currencies: {
    toman: 'Toman',
    rial: 'Rial'
  }
},
check_account_balance_and_try_again: 'Veuillez vérifier le solde de votre compte et réessayer',
problem_with_qr_renewal_request: 'Un problème est survenu lors de la demande de renouvellement du code QR',

  ERRORS: {
    PhoneIsNotValid:
      "Le numéro de téléphone saisi est invalide : ex. 09101234567",
    InvalidNumber: "La quantité saisie est invalide.",
    NoSelectedLineNumber: "Veuillez sélectionner une ligne d'expédition.",
    EmptyText: "Veuillez entrer le texte.",
    UnknownError: "Erreur inconnue",
    TryAgain: "Veuillez réessayer plus tard.",
    NoAccountCharge: "Solde insuffisant",
    NoAccess: "Accès refusé.",
    PleasebyeAPlane: "Veuillez acheter un forfait.",
    PleaseChargeYourAccount: "Veuillez recharger votre compte.",
    AccessDenied: "Accès refusé.",
    AccessDeniedDescription: "Contactez le support pour plus d'informations.",
    Error: "Erreur",
    InvalidText: "Texte invalide",
    InvalidTextContainsLink:
      "Seules les lignes de service peuvent contenir des liens.",
    NoPhoneToSend: "Il n'y a aucun numéro à qui envoyer.",
  },
  FORMS: {
    SuccsessFullySended: "Compris",
    DestinationPhone: "Numéro du destinataire",
    TestDestinationPhone: "Numéro de test",
    SourceNumber: "Numéro de l'expéditeur",
    Text: "Texte",
    CharCount: "Nombre de caractères",
    FarsiCharCount: "Nombre de caractères persans",
    EnglishCharCount: "Nombre de caractères anglais",
    Send: "Envoyer",
    SendTime: "Heure d'envoi",
    SendTest: "Envoi de test",
    SendToTestNumber: "Envoyer au numéro de test",
    SmsCount: "Nombre de SMS",
    SmsLang: "Langue du SMS",
    Add: "Ajouter",
    FromFile: "Ajouter depuis un fichier",
    TestNumber: "Numéro de test",
    Test: "Test",
    ServiceRelated: "Service/Transactionnel",
    Price: "Coût d'envoi liste blanche",
    TotalPrice: "Coût total",
    NumbersCount: "Nombre total de numéros",
    BlacklistPrice: "Coût d'envoi liste noire",
    BlacklistNumbersCount: "Nombre en liste noire",
    WhitelistNumbersCount: "Nombre en liste blanche",
    IrancellNumbersBlacklistCount: "Liste noire Irancell",
    HamrahavalNumbersBlacklistCount: "Liste noire Hamrah Aval",
    IrancellNumbersWhitelistCount: "Liste blanche Irancell",
    HamrahavalNumbersWhitelistCount: "Liste blanche Hamrah Aval",
    NumbersCountToSend: "Nombre de numéros valides",
    Search: "Rechercher",
    Title: "Titre",
    RequestTime: "Heure de la demande",
    RequestInformation: "Informations sur la demande",
    CreateNewPhoneBook: "Créer un nouveau répertoire",
    AddPhone: "Ajouter des numéros",
    Remove: "Supprimer",
  },
  unexpected_error: "Une erreur inattendue s'est produite. Veuillez réessayer.",
  luck_wheel_name: "Nom du QR de la roue de la chance",
  update_video: "Ajouter une galerie vidéo",
  edit: "Modifier",
  to_top: "Du haut",
  to_bottom: "Du bas",
  to_left: "De droite à gauche",
  to_right: "De gauche à droite",
  to_top_right: "Du bas à droite",
  to_top_left: "Du bas à gauche",
  to_bottom_right: "Du haut à droite",
  to_bottom_left: "Du haut à gauche",
  select_color_gradient: "Choisir un dégradé",
  select_color_solid: "Choisir une couleur unie",
  gradient_direction: "Direction du dégradé",
  gradient_background: "Arrière-plan dégradé",
  qr_downloaded_successfully: "QR téléchargé avec succès.",
  logo: "Logo",
  qr_design_size: "Design et taille du QR",
  qr_eye_design: "Design des yeux du QR",
  qr_markout: "Marge de sortie",
  frame: "Cadre",
  ready_card_samples: "Exemples de cartes de visite prêtes",
  ready_card_sample: "Exemple de carte de visite prête",
  remove_default_info: "Supprimer les infos par défaut",
  select_ready_card: "Sélectionner une carte prête",
  connection_code: "Code de connexion",
  enter_visit_card_info: "Saisir les infos de la carte de visite",
  info: "Informations",
  select_template_design: "Choisir un design de modèle",
  qr_address: "Adresse QR",
  visit_card_name: "Nom de votre carte de visite",
  visit_card_name_pro: "Nom de votre carte de visite Pro",
  download_qr: "Télécharger le QR",
  fast_design: "Design rapide",
  professional_design: "Design professionnel",
  ai_design: "Design par IA",
  update_qr: "Mettre à jour le QR",
  fast_design_message:
    "Vous êtes passé au design de code rapide. Le design précédent a été fait dans cette section.",
  professional_design_message:
    "Vous êtes passé au design de code professionnel. Le design précédent a été fait dans cette section.",
  scan_me: "Scannez-moi",
  visit_card_edited_successfully:
    "Votre carte de visite a été modifiée avec succès.",
  customer_club_membership: "Adhésion au club clients",
  qrland: "QR Land",
  dynamic: "Dynamique",
  about_us_text:
    "Caractéristiques du QR code dynamique :\n✔️ Édition illimitée\n✔️ Scan facile\n✔️ Limitation de scans\n✔️ Ajout de mot de passe\n✔️ Statistiques des visiteurs\n✔️ Changement de couleur et apparence\n✔️ Sécurité des données\n✔️ Ajout de photo et logo\n✔️ QR spécialisé selon le besoin\n✔️ Redirection vers liens et site\n✔️ QR + lien court ensemble\n✔️ Utilisable sur tous les réseaux (hors ligne/en ligne)\n✔️ Téléchargeable dans tout format\n✔️ Imprimable sur toute surface et taille",
  video_gallery: "Galerie vidéo",
  address_text: "Paris, 6 Rue de Rivoli, Bâtiment 6",
  visit_card: "Carte de visite",
  qrland_system: "Système QR Land",
  qrland_first_system: "Premier système de création de QR code dynamique",
  address: "Adresse",
  enter_site_link: "Entrez le lien du site souhaité",
  instagram: "Instagram",
  enter_instagram_username: "Entrez votre nom d'utilisateur",
  whatsapp: "WhatsApp",
  invalid_qr_address: "L'adresse saisie n'est pas valide !",
  visit_card_created_successfully:
    "Votre carte de visite a été créée avec succès.",
  qr_creation_failed: "Échec de la création du QR !",
  manage_password: "Gestion du mot de passe",
  hour_limit: "Limite horaire",
  scan_click_limit: "Limite de scans/clics",
  redirect_scanner: "Rediriger le scanneur",
  edit_settings_error: "Erreur lors de la modification des paramètres !",
  next: "Suivant",
  add: "Ajouter",
  header_color_settings: "Paramètres de couleur et texte d'en-tête",
  select_image: "Choisir une image",
  enter_qr_address: "Entrez votre adresse QR",
  qr_idea_title: "Idée de création de QR",
  qr_idea: "Idée QR",
  qr_idea_subject: "Sujet de création QR",
  confirm_qr_idea: "Confirmer mon idée QR",
  scannable: "Scannable",
  ai_sample: "Exemple généré par IA...",
  scan_warning:
    "Peut ne pas être scanné sur tous les appareils. Réessayez en cas d'échec.",
  ai_description: "Décrivez le QR souhaité, l'IA le créera pour vous.",
  attach: "Joindre",
  remaining: "Restant",
  qr_creation: "Création de QR",
  free: "Gratuit",
  select_language_for_request: "Choisir la langue pour le texte de demande",
  request_text: "Texte de demande",
  request_text_placeholder: "Décrivez le lien QR souhaité...",
  strengthen_text: "Renforcer le texte existant",
  prompt_idea: "Idée de prompt",
  try_again: "Réessayer",
  create_qr: "Créer un QR",
  smart_qr_code: "QR code intelligent",
  regenerate_image: "Regénérer l'image",
  updating_qr: "Mise à jour du QR...",
  copied: "Copié",
  copy: "Copier",
  print_qr: "Imprimer le QR",
  print_visit_card: "Imprimer la carte de visite",
  send_link: "Envoyer le lien",
  customer_list: "Liste des clients",
  order_list: "Liste des commandes",
  reserved_appointments: "Rendez-vous réservés",
  feedback: "Retour",
  request_form: "Formulaire de demande",
  transfer_ownership: "Transférer la propriété",
  select_nfc_card: "Sélectionner une carte NFC",
  created_at: "Créé le",
  last_edit: "Dernière modification",
  qr_card: "Carte QR",
  viewed: "Vu",
  see_more: "Voir plus",
  download: "Télécharger",
  activate: "Activer",
  design: "Design",
  qr_settings: "Paramètres QR",
  deactivate: "Désactiver",
  qr_color_size: "Couleur et taille du QR",
  dots_design_color: "Design et couleur des points",
  eye_design_color: "Design et couleur des yeux",
  border_design_color: "Design et couleur de bordure",
  logo_settings: "Paramètres du logo",
  download_qr_comment: "Télécharger le QR",
  connection_established: "Connexion établie.",
  show_qr: "Afficher le QR",
  preview: "Aperçu",
  user_info: "Infos utilisateur",
  sms_club_membership: "Adhésion au club SMS",
  smart_settings: "Paramètres intelligents",
  add_audio_file: "Ajouter un fichier audio",
  back: "Retour",
  after_click_location:
    "Après avoir cliqué sur la localisation, choisissez votre application de carte.",
  phone_number: "Numéro de téléphone",
  auto_display: "Affichage automatique",
  customer_club: "Club clients",
  auto_download: "Téléchargement automatique",
  save: "Enregistrer",
  about_us: "À propos",
  view_more: "Voir plus",
  view_less: "Voir moins",
  audio_file: "Fichier audio",
  add_video: "Ajouter une vidéo",
  add_image: "Ajouter une image",
  select_color: "Choisir une couleur",
  header_color: "Texte d'en-tête",
  add_social_networks: "Ajouter des réseaux sociaux",
  format: "Format",
  output_size: "Taille de sortie",
  file_type: "Type de fichier",
  default: "Par défaut",
  qr_download_error: "Erreur lors du téléchargement du QR. Réessayez",
  header_color_text_settings: "Paramètres de couleur et texte d'en-tête",
  upload_catalog_images: "Téléverser les images du catalogue / brochure",
  delete: "Supprimer",
  personal_domain: "Domaine personnel",
  no_domain_found: "Aucun domaine trouvé !",
  enter_domain_address: "Veuillez saisir l'adresse de votre domaine",
  dns_setup_note: "N'oubliez pas de configurer d'abord les DNS du serveur !",
  attention: "Attention : ",
  dns_setup_instruction:
    "Pour enregistrer un domaine personnel, configurez d'abord les DNS",
  and: "et",
  setup_on_domain: "sur votre domaine.",
  dns_change_time: "(Le changement de DNS peut prendre jusqu'à 24 heures)",
  add_domain: "Ajouter un domaine",
  add_personal_domain: "Ajouter un domaine personnel",
  min_characters: "Nombre minimum de caractères",
  domain_format:
    "Le domaine doit être au format https://terminalads.com ou terminalads.com.",
  invalid_domain: "Le domaine saisi n'est pas valide !",
  domain_added_successfully: "Votre domaine a été ajouté avec succès",
  invalid_dns_settings: "Les paramètres DNS ne sont pas valides !",
  deleted_successfully: "Supprimé avec succès",
  location: "Localisation",
  save_contact: "Enregistrer le contact",
  search: "Rechercher",
  data_fetch_error: "Erreur lors de la récupération des données !",
  error: "Erreur",
  view_qr: "Voir le QR",
  qr_design: "Design du QR",
  register: "S'inscrire",
  terminal_ads: "Terminal Publicité",
  manage_40_advertising_methods:
    "Gérez 40 méthodes publicitaires en même temps !",
  ms_khansari: "Mme Khansari",
  support: "Support",
  comprehensive_advertising_system:
    "Le seul système complet d'analyse et de gestion des publicités en ligne",
  terminal_ads_description:
    "Le système Terminal Publicité est fier de maintenir une communication continue et efficace avec ses clients et utilisateurs pour comprendre leurs besoins et leur offrir les meilleures solutions. Notre plus grand capital est constitué de nos clients et utilisateurs fidèles, suivi de notre équipe d’experts qui soutient l’entreprise avec des idées nouvelles et des technologies modernes.",
  please_enter_qr_address_correctly:
    "Veuillez saisir correctement l'adresse QR !",
  server_error: "Erreur serveur !",
  please_enter_your_address: "Veuillez saisir votre adresse",
  please_enter_instagram_address: "Veuillez saisir votre adresse Instagram",
  please_enter_whatsapp_address: "Veuillez saisir votre adresse WhatsApp",
  enter_information: "Saisir les informations",
  dynamic_qr: "QR dynamique",
  coming_soon: "Bientôt",
  qr_name: "Nom du QR",
  for_default_address_leave_empty: "!Laissez vide pour l'adresse par défaut",
  default_address: "Adresse par défaut",
  sms: "SMS",
  enter_number_without_zero: "Saisissez le numéro sans 0.",
  number: "Numéro",
  country_code: "Code pays :",
  sms_text: "Texte du SMS",
  complete_sms_fields_correctly:
    "Veuillez remplir correctement les champs SMS !",
  qr_code_created_successfully: "Votre code QR a été créé avec succès.",
  chat: "Chat",
  call: "Appel",
  please_enter_username: "Veuillez entrer votre nom d'utilisateur.",
  username: "Nom d'utilisateur",
  sample_menu: "Menu d'exemple",
  online_menu_name: "Nom de votre menu en ligne",
  online_menu_name_short: "Nom du menu en ligne",
  enter_menu_information: "Entrez les informations du menu",
  select_sample_menu: "Sélectionnez un menu d'exemple",
  select_ready_menu: "Sélectionnez un menu prêt",
  online_sales: "Ventes en ligne",
  sales_settings: "Paramètres de vente",
  photo_gallery: "Galerie photo",
  fast_food1: "Fast Food 1",
  fast_food2: "Fast Food 2",
  products: "Produits",
  pizzas: "Pizzas",
  pizza_rust_beef: "Pizza Roastbeef",
  italian_pizza_with_beef: "🤩 Pizza italienne au bœuf",
  italian_pizza_dough_30cm: "Pâte à pizza italienne 30 cm",
  "100g_shredded_beef": "100 g de bœuf effiloché",
  mushroom_bell_pepper: "Champignons, poivron",
  black_olives: "Olives noires",
  pizza_chicken_mushroom: "Pizza poulet & champignons",
  classic_40cm: "🍕 Classique 40 cm",
  fresh_tomato_sauce:
    "Sauce tomate fraîche, fromage, filet de poulet, champignons, thym de montagne",
  pizza_meat_mushroom: "Pizza viande & champignons",
  meat_pizza_with_mushroom: "🥰 Pizza au viande hachée et champignons",
  pizza_vegetables: "Pizza aux légumes",
  american_vegetable_pizza: "🍕 Pizza américaine aux légumes",
  american_pizza_dough:
    "Pâte à pizza américaine, maïs, champignons, olives, tomates, oignons, poivron, fromage",
  special_pizza: "Pizza spéciale",
  american_special_pizza: "Pizza spéciale américaine",
  pizza_bolognese: "Pizza bolognaise",
  one_person_23cm: "(1 personne) Pâte à pizza 23 cm 🤌",
  pepperoni_pizza: "Pizza pepperoni",
  one_person_23cm_dough: "(1 personne) Pâte à pizza 23 cm",
  bacon_pizza: "Pizza bacon",
  one_person_23cm_explosion: "(1 personne) Pâte à pizza 23 cm 💥",
  mixed_pizza: "Pizza mixte",
  one_person_23cm_mixed: "(1 personne) Pâte à pizza 23 cm 🤭",
  american_steak_pizza: "Pizza steak américaine",
  one_person_23cm_steak: "(1 personne) 23 cm 💥",
  burgers: "Burgers",
  cheese_burger: "Cheeseburger",
  with_french_fries: "🤩 avec frites",
  "2_beef_burgers_150g": "2 burgers de bœuf de 150 g chacun",
  special_sauce_gouda_cheese: "Sauce spéciale, fromage Gouda",
  pickles_lettuce_tomato: "Cornichons, laitue, tomate",
  special_sauce: "Sauce spéciale",
  burger: "Burger",
  pure_meat_with_special_sauce: "😍 Viande pure avec sauce spéciale",
  chicken_burger: "Burger au poulet",
  grilled_chicken_burger_with_cheese: "Burger au poulet grillé avec fromage",
  spicy_burger: "Burger épicé",
  beef_with_spicy_sauce: "Bœuf avec sauce épicée",
  double_burger: "Double burger",
  "150g_beef": "Bœuf 150 g",
  royal_burger: "Burger royal",
  "150g_beef_emoji": "150 g de bœuf 🍔",
  mushroom_burger: "Burger aux champignons",
  "150g_beef_mushroom": "Bœuf 150 g",
  mushroom_burger_grilled: "Burger aux champignons",
  "100_percent_grilled_beef": "100 % bœuf grillé 🤩",
  fried_burger: "Burger frit",
  "100_percent_grilled_fried": "100 % bœuf grillé et frit 👌",
  fried: "Frit",
  fried_chicken: "Poulet frit",
  "3_piece_fried_chicken": "😍 3 morceaux de poulet frit",
  "3_fried_chicken_pieces": "3 morceaux de poulet frit",
  "120_150g_french_fries": "120-150 g de frites",
  enter_product_information: "Entrez les informations du produit",
  product_name: "Nom de votre produit",
  product_name_short: "Nom du produit",
  complete_features_from_image:
    "Complétez les caractéristiques à partir de l'image du produit",
  skip_step: "Passer l'étape",
  product_and_information: "Produit et informations",
  product_introduction: "Présentation du produit",
  shiva_waves: "Ondes Shiva",
  think_best: "Pensez au mieux...",
  iran_zanjan_abhar:
    "Iran, Zanjan, Abhar, Zone industrielle Sharif, à côté du poste 63/20 kV",
  video_gallery_description: "Regardez nos vidéos.",
  gallery: "Galerie",
  welcome: "Bienvenue",
  invalid_address: "L'adresse saisie est invalide !",
  product_created_successfully: "Votre produit a été créé avec succès.",
  qr_visit_card_edited_successfully:
    "Votre carte de visite a été modifiée avec succès.",
  change_header_color: "Changer la couleur de l'en-tête",
  change_body_color: "Changer la couleur du corps",
  change_button_colors: "Changer les couleurs des boutons",
  change_text_colors: "Changer les couleurs du texte",
  gradient_colors: "Couleurs dégradées",
  color_direction: "Direction de la couleur",
  first_color: "Première couleur",
  second_color: "Deuxième couleur",
  color: "Couleur",
  text_color: "Couleur du texte",
  from_top: "Depuis le haut",
  from_bottom: "Depuis le bas",
  from_left_to_right: "De gauche à droite",
  from_right_to_left: "De droite à gauche",
  from_top_to_left: "En haut à gauche",
  from_top_to_right: "En haut à droite",
  from_bottom_to_left: "En bas à gauche",
  from_bottom_to_right: "En bas à droite",
  sharing: "Partage",
  business_shop: "Entreprise / Boutique",
  corporate_organizational: "Société / Organisation",
  customer_contact: "Contact client",
  information: "Informations",
  miscellaneous: "Divers",
  link: "Lien",
  margin: "Marge",
  width: "Largeur",
  height: "Hauteur",
  background_color: "Couleur de fond",
  gradient_color: "Couleur dégradée",
  linear: "Linéaire",
  radial: "Radial",
  color_rotation: "Rotation de couleur",
  background_color_label: "Couleur de fond",
  dots_color: "Couleur des points",
  dots_color_label: "Couleur des points",
  eye_colors: "Couleurs des yeux",
  separate_colors_for_each_eye: "Couleurs séparées pour chaque œil",
  current_mode: "Mode actuel :",
  separate_colors: "Couleurs séparées",
  same_color: "Même couleur",
  all_eyes_color: "Couleur de tous les yeux",
  top_right_eye: "Œil en haut à droite",
  top_left_eye: "Œil en haut à gauche",
  bottom_left_eye: "Œil en bas à gauche",
  upload_logo: "Télécharger le logo",
  hide_background_dots: "Masquer les points derrière le logo",
  logo_size: "Taille du logo",
  logo_margin: "Marge du logo",
  qr_accuracy: "Précision du QR",
  mode: "Mode",
  error_correction_level: "Niveau de correction d'erreur",
  numeric: "Numérique",
  alphanumeric: "Alphanumérique",
  byte: "Octet",
  apply_changes: "Appliquer les modifications",
  please_click_apply_changes:
    'Cliquez sur "Appliquer les modifications" après avoir sélectionné les ajustements.',
  created_qr_codes: "Codes QR créés",
  square_ratio: "1:1 (carré)",
  image_upload_error: "Erreur de téléchargement d'image !",
  visit_card_name_label: "Nom de la carte de visite",
  sms_membership_message: "Message d'adhésion SMS pour le club client",
  admin_menu: "Menu Admin",
  user_menu: "Menu Utilisateur",
  guide_tooltip: "Guide",
  close: "Fermer",
  browser_video_support_error:
    "Votre navigateur ne prend en charge aucun format vidéo.",
  video_loading_error:
    "Erreur de chargement de la vidéo (accès peut être restreint).",
  click_more_for_videos: "Cliquez sur Plus pour voir plus de vidéos.",
  more_info: "Plus d'informations",
  more: "Plus",
  add_user_guide: "Ajouter un guide utilisateur",
  edit_user_guide: "Modifier le guide utilisateur",
  display_info: "Afficher les informations",
  element: "Élément",
  disable_attach: "Désactiver la pièce jointe pour adapter à la page",
  view: "Voir",
  guide: "Guide",
  details: "Détails",
  guide_images: "Images du guide",
  guide_videos: "Vidéos du guide",
  faq: "Questions fréquemment posées",
  data_preload_error: "Erreur de préchargement des données :",
  guide_not_found: "Aucun guide trouvé. Créez d'abord un guide.",
  delete_guide_question: "Supprimer le guide ?",
  delete_guide_error: "Erreur lors de la suppression du guide !",
  unknown_file_type: "Type de fichier inconnu :",
  content_type_error: "Erreur de réception du type de contenu :",
  video: "Vidéo",
  image: "Image",
  guide_data_error: "Erreur de réception des données du guide :",
  add_iranian_stores: "Ajouter des magasins iraniens",
  add_foreign_stores: "Ajouter des magasins étrangers",
  bazaar: "Bazaar",
  myket: "Myket",
  app_store: "App Store",
  google_play: "Google Play",
  samsung_store: "Samsung Store",
  xiaomi_store: "Xiaomi Store",
  vivo_store: "Vivo Store",
  amazon_store: "Amazon Store",
  bazaar_app: "Application Bazaar",
  bazaar_link_placeholder: "Entrez le lien de l'application Bazaar",
  bazaar_link_hint:
    "Entrez un lien Bazaar valide (ex. https://cafebazaar.ir/app/com.abankefarda)",
  myket_app: "Application Myket",
  myket_link_placeholder: "Entrez le lien de l'application Myket",
  myket_link_hint:
    "Entrez un lien Myket valide (ex. myket://details?id=com.example)",
  app_store_app: "Application App Store",
  app_store_link_placeholder: "Entrez le lien de l'application App Store",
  app_store_link_hint:
    "Entrez un lien App Store valide (ex. https://apps.apple.com/fr/app/appname/id123456789)",
  google_play_app: "Application Google Play",
  google_play_link_placeholder: "Entrez le lien de l'application Google Play",
  google_play_link_hint:
    "Entrez un lien Google Play valide (ex. https://play.google.com/store/apps/details?id=com.example)",
  samsung_store_app: "Application Samsung Store",
  samsung_store_link_placeholder:
    "Entrez le lien de l'application Samsung Store",
  samsung_store_link_hint:
    "Entrez un lien Samsung Store valide (ex. https://galaxy.store/appname)",
  xiaomi_store_app: "Application Xiaomi Store",
  xiaomi_store_link_placeholder: "Entrez le lien de l'application Xiaomi Store",
  xiaomi_store_link_hint: "Entrez un lien Xiaomi Store valide",
  vivo_app_store: "Vivo App Store",
  vivo_app_store_app: "Application Vivo App Store",
  vivo_app_store_link_placeholder:
    "Entrez le lien de l'application Vivo App Store",
  vivo_app_store_link_hint: "Entrez un lien Vivo App Store valide",
  amazon_store_app: "Application Amazon Store",
  amazon_store_link_placeholder: "Entrez le lien de l'application Amazon Store",
  amazon_store_link_hint: "Entrez un lien Amazon Store valide",
  iranian_store: "Magasin iranien",
  foreign_store: "Magasin étranger",
  personal_store: "Magasin personnel",
  image_logo: "Image/Logo",
  image_gallery: "Galerie d'images",
  header_image: "Image d'en-tête",
  template_background_image: "Image de fond de modèle",
  background_image: "Image de fond",
  background_image_alt: "Image de fond",
  logo_upload: "Télécharger le logo",
  welcome_image: "Image de bienvenue",
  welcome_image_logo_upload: "Télécharger l'image/logo de bienvenue",
  loading_animation: "Animation de chargement",
  preview_welcome_page: "Aperçu de la page de bienvenue",
  max_background_size: "Taille maximale par image de fond : 2 Mo.",
  max_logo_size: "Taille maximale par logo : 2 Mo.",
  scale_from_center: "Échelle depuis le centre",
  slide_from_left: "Glisser depuis la gauche",
  slide_from_top: "Glisser depuis le haut",
  fade: "Fondu",
  select_music_card: "Sélectionner la carte musicale",
  show_audio: "Afficher l'audio",
  hide_audio: "Masquer l'audio",
  add_voice: "Ajouter une voix",
  max_files_limit: "Vous ne pouvez pas sélectionner plus de {count} fichiers !",
  files_not_allowed: "Fichiers non autorisés !",
  voice_gallery: "Galerie vocale",
  edit_voice: "Modifier la voix",
  list: "Liste",
  file_name: "Nom du fichier",
  title: "Titre",
  description: "Description",
  selectdate: "Sélectionner la date",
  background: "Arrière-plan",
  text: "Texte",
  delete_audio_confirm:
    "Êtes-vous sûr de vouloir supprimer le fichier audio de votre galerie ?",
  add_voice_gallery: "Ajouter une galerie vocale",
  gallery_number: "Galerie",
  delete_confirm: "Êtes-vous sûr de vouloir supprimer ?",
  confirm: "?",
  voice_gallery_title_hint: "Entrez le titre de votre galerie vocale.",
  voice_gallery_title: "Titre",
  voice_gallery_subtitle_hint: "Entrez le sous-titre de votre galerie vocale.",
  voice_gallery_subtitle: "Sous-titre de la galerie vocale",
  voice_gallery_subtitle_alt: "Sous-titre",
  website_address_hint: "Entrez votre adresse de site web.",
  website_address: "Adresse du site web",
  about_voice_gallery: "À propos de la galerie",
  about_voice_gallery_alt: "À propos de la galerie",
  button_name_hint: "Entrez le nom du bouton.",
  button_name: "Nom du bouton",
  domain_format_hint:
    "Le domaine doit être https://terminalads.com ou terminalads.com.",
  about_us_alt: "À propos de nous",
  add_default_form: "Ajouter un formulaire par défaut",
  delete_all: "Tout supprimer",
  validation_active: "Validation : Active",
  validation_inactive: "Validation : Inactive",
  validation: "Validation",
  clear_form: "Effacer le formulaire",
  status: "Statut",
  active: "Actif",
  inactive: "Inactif",
  optional: "Optionnel",
  required: "Requis",
  question_title: "Titre",
  question_title_hint: "Entrez le titre de la question",
  options_hint: "Écrivez les options et appuyez sur Entrée pour ajouter",
  options: "Options",
  add_suggested_form: "Ajouter un formulaire suggéré",
  save_changes: "Enregistrer les modifications",
  add_request_field: "Ajouter un champ de demande",
  select_form_type: "Sélectionner le type de formulaire",
  select_form_type_placeholder: "Sélectionner le type de formulaire",
  dropdown: "Menu déroulant",
  text_field: "Champ texte",
  number_field: "Champ numérique",
  textarea_field: "Zone de texte",
  date_field: "Champ date",
  field_name_required: "Le nom du champ ne peut pas être vide",
  field_name: "Nom du champ",
  add_field_name: "Ajouter un nom de champ",
  field_label: "Étiquette du champ",
  add_field_label: "Ajouter une étiquette de champ",
  advanced_settings: "Paramètres avancés",
  select_input_pattern: "Sélectionner le modèle d'entrée",
  select_input_pattern_placeholder: "Sélectionner le modèle d'entrée",
  max_characters: "Nombre maximal de caractères",
  min_input_error: "L'entrée minimale doit être 0",
  name_field: "Nom",
  field_type: "Type de champ",
  persian_limit: "Restriction de langue persane",
  family_name: "Nom de famille",
  mobile_number: "Numéro de mobile",
  number_limit: "Restriction numérique",
  national_code: "Code national",
  meli_code: "Code national",
  email: "E-mail",
  email_limit: "Restriction e-mail",
  dropdown_field: "Champ menu déroulant",
  english_limit: "Restriction de langue anglaise",
  mix_per_eng_limit: "Restriction mixte persan-anglais",
  site_limit: "Restriction de site",
  form_added_successfully: "Nouveau formulaire ajouté avec succès",
  form_updated_successfully: "Formulaire mis à jour avec succès",
  delete_item_confirm: "Êtes-vous sûr de vouloir supprimer l'élément ?",
  default_form_added_successfully: "Formulaire par défaut ajouté avec succès",
  resources_upload_error: "Erreur de téléchargement des ressources",
  update_value_if_duplicate: "Mettre à jour la valeur si dupliquée",
  first_tab: "Premier onglet",
  display_count: "Nombre d'affichages",
  buy_renew_qr_instruction:
    "Pour acheter/renouveler un QR, cliquez sur le bouton de durée d'expiration.",
  days_until_expiry: "Jours jusqu'à l'expiration",
  expired: "Expiré",
  no_qr_to_display: "Aucun QR à afficher !",
  second_tab: "Deuxième onglet",
  total_qr_codes: "Total des codes QR",
  select_all: "Tout sélectionner",
  selected_qr_codes_count: "Nombre de codes QR sélectionnés",
  qr_codes_count: "Nombre de codes QR",
  group_renewal_instruction:
    "Pour un renouvellement de groupe, sélectionnez les codes QR souhaités.",
  no_qr_found_with_filters: "Aucun QR trouvé avec ces filtres !",
  qr_codes_count_label: "Nombre de codes QR :",
  renew_qr: "Renouveler le QR",
  days: "Jours",
  buy_now: "Acheter maintenant !",
  buy_now_label: "Acheter",
  add_discount_code: "Ajouter un code de réduction",
  use_discount_code: "Utiliser un code de réduction",
  discount_code: "Code de réduction",
  submit: "Soumettre",
  my_qr_list: "Ma liste QR",
  group_renewal: "Renouvellement de groupe",
  row: "Ligne",
  type: "Type",
  clicks: "Clics",
  created_at_diff: "Heure de création",
  updated_at_diff: "Heure de mise à jour",
  table_view: "Vue tableau",
  normal_view: "Vue normale",
  no_qr_or_id_selected: "Aucun QR ou ID sélectionné !",
  qr_updated_successfully: "QR mis à jour avec succès.",
  qr_update_error: "Erreur de mise à jour du QR !",
  no_qr_selected: "Aucun QR sélectionné !",
  no_qr_code_selected: "Aucun code QR sélectionné !",
  success: "Succès",
  qrs_upgraded_successfully: "Vos QR ont été mis à jour avec succès.",
  qr_renewal_error: "Problème avec la demande de renouvellement du QR !",
  changed_successfully: "Modifié avec succès.",
  error_occurred: "Une erreur s'est produite !",
  no_tariff_exists: "Aucun tarif n'existe !",
  qr_upgraded_successfully: "Votre QR a été mis à jour avec succès.",
  check_account_balance:
    "Vérifiez le solde de votre compte et réessayez plus tard.",
  group_renewal_price_error:
    "Erreur de récupération du prix de renouvellement de groupe !",
  qr_count_error: "Erreur de récupération du nombre de QR !",
  no_qr_for_renewal: "Aucun QR à renouveler !",
  table_pagination: "Pagination du tableau",
  virtual_scroll_display: "Affichage défilement virtuel",
  popups_shared_components: "Pop-ups et composants partagés",
  edit_qr_address: "Modifier l'adresse QR",
  please_enter_correct_address: "Veuillez entrer une adresse correcte",
  successfully_edited: "Modifié avec succès.",
  error_editing_qr_address: "Erreur de modification de l'adresse QR !",
  go_to_page: "Aller à la page",
  page_from_to: "Page {current} sur {last}",
  display: "Afficher",
  to: "à",
  from: "de",
  show: "Afficher",
  page_status: "Page {current} sur {total}",
  until: "jusqu'à",
  successfully_completed: "Terminé avec succès",
  problem_occurred: "Un problème est survenu",
  download_failed: "Téléchargement échoué",
  audio_file_default: "Fichier audio",
  memory_release: "Libération de mémoire",
  seek_music_comment: "Par exemple cette musique ou tout ce qui est recherché",
  all: "Tout",
  create_podcast: "Créer un podcast",
  add_link: "Ajouter un lien",
  upload_file: "Télécharger un fichier",
  file_list: "Liste des fichiers",
  count: "Nombre",
  select_category: "Sélectionner la catégorie",
  after_typing_enter: "Après avoir tapé, appuyez sur Entrée.",
  no_image_available: "Aucune image disponible",
  no_image_found: "Aucune image trouvée !",
  for_adding_file_use_upload_center:
    "Pour ajouter un fichier, utilisez le champ de téléchargement ou le centre de téléchargement",
  ai_story_creation_description:
    "Entrez votre histoire, l'IA la créera pour vous",
  create_new_podcast: "Créer un nouveau podcast",
  show_audio_file: "Afficher le fichier audio",
  cancel: "Annuler",
  no_audio_in_category: "Aucun fichier audio dans cette catégorie",
  health_apple: "Pomme santé",
  standard: "Standard",
  arshia_badge: "Badge Arshia",
  home_appliances_association: "Association des appareils ménagers",
  energy_label: "Étiquette énergétique",
  select_gold_purity_first:
    "Pour obtenir le prix, sélectionnez d'abord la pureté de l'or",
  gold_price_service: "Service de prix de l'or",
  rahvard: "Rahvard",
  to_change_gold_service_go_to_assets:
    "Pour changer le service de prix de l'or, allez à la section actifs",
  gold: "Or",
  purity: "Pureté",
  rial: "Rial",
  final_product_price: "Prix final du produit",
  show_images_right_side: "Afficher les images à droite",
  show_as_slider: "Afficher en tant que diaporama.",
  show_as_grid: "Afficher en grille.",
  show_as_second_mode: "Afficher en second mode.",
  gallery_name: "Nom de la galerie",
  change_gallery_name: "Changer le nom de la galerie",
  add_photo: "Ajouter une photo",
  select_photo: "Sélectionner une photo",
  show_image: "Afficher l'image",
  selected_photo: "Photo sélectionnée",
  to_use_ready_images_search_category_or_product:
    "Pour utiliser des images prêtes, recherchez la catégorie ou le produit ci-dessus.",
  max_file_size_2mb: "Taille maximale du fichier : 2 Mo.",
  drag_and_drop_to_upload_or: "Glissez-déposez pour télécharger ou",
  here: "ici",
  click: "cliquez",
  to_use_external_image_link_fill_fields:
    "Pour utiliser un lien d'image externe, remplissez les champs ci-dessous",
  image_url_hint: "URL de l'image souhaitée (lien).",
  image_url: "Lien de l'image",
  add_new_gallery: "Ajouter une nouvelle galerie",
  create_image: "Créer une image",
  ready_images: "Images prêtes",
  edit_image: "Modifier l'image",
  enter_valid_link: "Entrez un lien valide.",
  max_background_image_size_2mb: "Taille maximale par image de fond : 2 Mo.",
  uploaded_successfully: "Téléchargé avec succès.",
  banner: "Bannière",
  question: "Question",
  selected_question: "Question sélectionnée",
  answer: "Réponse",
  add_question: "Ajouter une question",
  selected_blog: "Blog sélectionné",
  icon: "Icône",
  select_icon: "Sélectionner une icône",
  add_blog: "Ajouter un blog",
  post: "Article",
  selected_services: "Services sélectionnés",
  add_new_post: "Ajouter un nouvel article",
  add_new_services: "Ajouter de nouveaux services",
  add_new_service: "Ajouter un nouveau service",
  domain_must_be_https_or_http:
    "Le domaine doit être https://terminalads.com ou terminalads.com.",
  id: "ID",
  images: "Images",
  tags: "Étiquettes",
  print_type: "Type d'impression",
  user: "Utilisateur",
  user_shipping_info: "Informations d'expédition de l'utilisateur",
  qr_short_link: "Lien court QR",
  delivery_method: "Méthode de livraison",
  delivery_at_company: "Livraison à l'entreprise",
  delivery_by_post: "Livraison par courrier",
  post_cost_and_tax_warning:
    "Lors de l'enregistrement, les frais de port et 10 % de taxe seront déduits de votre portefeuille.",
  shipping_info: "Informations d'expédition",
  continue_shopping: "Continuer les achats",
  complete_shopping: "Finaliser l'achat",
  select_free_nfc_card: "Sélectionner une carte NFC gratuite",
  order_custom_nfc_card: "Commander une carte NFC personnalisée",
  buy_qr_equipment: "Acheter l'équipement QR",
  vertical: "Vertical",
  horizontal: "Horizontal",
  card_type: "Type de carte",
  tag: "Étiquette",
  select: "Sélectionner",
  order_card: "Commander la carte",
  available: "Disponible",
  unavailable: "Indisponible",
  for_initial_loading: "Pour le chargement initial",
  already_have_free_nfc_message:
    "Vous avez déjà reçu une NFC gratuite pour ce QR. Pour changer, achetez une carte personnalisée.",
  nfc_in_delivery_process_message:
    "Vous avez déjà enregistré une NFC gratuite en cours de livraison. Pour changer, achetez une personnalisée.",
  free_nfc_card_warning_message:
    "Cher utilisateur : Les cartes NFC gratuites sont pré-imprimées, votre QR change. Si utilisé, achetez une personnalisée.",
  select_card: "Sélectionner la carte",
  free_card_selection_conditions:
    "Conditions de sélection de la carte gratuite",
  confirm_and_select: "Confirmer et sélectionner",
  registered_successfully: "Enregistré avec succès.",
  error_registering_nfc_order:
    "Erreur d'enregistrement de la commande de carte NFC !",
  nfc_physical_card_orders: "Commandes de cartes NFC physiques",
  buy_equipment: "Acheter l'équipement",
  select_quantity: "Sélectionner la quantité",
  ready_samples: "Échantillons prêts",
  upload_custom_design: "Télécharger un design personnalisé",
  select_ready_card_image: "Sélectionner une image de carte prête",
  select_card_front_image: "Sélectionner l'image avant de la carte",
  select_card_back_image: "Sélectionner l'image arrière de la carte",
  nfc_card_image: "Image de carte NFC",
  add_quantity: "Ajouter la quantité",
  total_price: "Prix total",
  price_with_discount: "Prix avec réduction",
  shipping_cost: "Frais de port",
  your_profit_from_purchase: "Votre profit de l'achat",
  discount: "Réduction",
  ten_percent_tax_will_be_added:
    "10 % de taxe seront ajoutés au montant final.",
  payable_amount: "Montant à payer",
  continue: "Continuer",
  Confirm_code: "Confirmer le code",
  form_success_message: "Votre formulaire a été envoyé avec succès",
  refill_form_message: "Veuillez remplir à nouveau le formulaire",
  Enter_the_sent_code: "Entrez le code qui vous a été envoyé",
  SUBMIT_FORM: "Soumettre le formulaire",
  enter_phone_number: "Entrez votre numéro de mobile",
  order_registered_successfully:
    "Votre commande a été enregistrée avec succès.",
  smart_creation: "Création intelligente",
  automatic_creation: "Création automatique",
  business_name: "Nom de l'entreprise",
  example_household_goods: "Exemple : Articles ménagers",
  organization_name: "Nom de l'organisation",
  example_tech_company: "Exemple : Entreprise technologique avancée",
  minimum_two_characters_required: "Au moins deux caractères requis !",
  maximum_100_characters_allowed: "Maximum 100 caractères autorisés",
  latin_name_qr_address: "Nom latin (adresse QR)",
  example_advanced_tech: "Exemple : advanced-tech",
  only_english_numbers_dash_allowed:
    "Seules les lettres anglaises, chiffres et tiret autorisés",
  maximum_50_characters_allowed: "Maximum 50 caractères autorisés",
  latin_name_goes_after_domain: "Le nom latin vient après le domaine",
  select_logo_and_store_product_image:
    "Sélectionnez le logo et l'image de magasin/produit",
  select_logo: "Sélectionner le logo",
  file_size_must_be_less_than_2mb:
    "La taille du fichier doit être inférieure à 2 Mo",
  for_buying_renewing_qr_click_expiry_button:
    "Pour acheter/renouveler un QR, cliquez sur le bouton de durée d'expiration.",
  for_group_renewal_select_desired_qr_codes:
    "Pour un renouvellement de groupe, sélectionnez les codes QR souhaités.",
  no_qr_found_with_these_filters: "Aucun QR trouvé avec ces filtres !",
  i_buy: "J'achète",
  visits: "Visites",
  creation_time: "Heure de création",
  edit_time: "Heure de modification",
  enter_business_card_name_correctly:
    "Entrez correctement le nom de la carte de visite !",
  are_you_sure_delete_qr: "Êtes-vous sûr de vouloir supprimer le QR ?",
  qr_deleted_successfully: "QR supprimé avec succès.",
  are_you_sure_deactivate_qr: "Êtes-vous sûr de vouloir désactiver le QR ?",
  are_you_sure_activate_qr: "Êtes-vous sûr de vouloir activer le QR ?",
  deactivated: "Désactivé",
  qr_successfully: "QR avec succès",
  successfully: "Avec succès",
  user_transferred_successfully: "Utilisateur transféré avec succès",
  problem_occurred_in_transfer: "Problème survenu lors du transfert !",
  error_in_user_transfer: "Erreur dans le transfert d'utilisateur !",
  qr_business_card_edited_successfully:
    "Votre carte de visite a été modifiée avec succès.",
  group_qr_renewal: "Renouvellement de groupe des QR",
  select_desired_duration: "Sélectionnez la durée souhaitée",
  total_count: "Nombre total",
  final_amount: "Montant final",
  ten_percent_vat_will_be_added:
    "10 % de TVA seront ajoutés au montant ci-dessus.",
  pay_and_upgrade: "Payer et mettre à niveau",
  no_tariff_for_this_period: "Aucun tarif pour cette période !",
  selected: "Sélectionné",
  total_amount: "Montant total",
  final_amount_with_discount: "Montant final avec réduction",
  add_qr: "Ajouter QR",
  actions: "Actions",
  filter_type: "Filtre de type",
  start_from: "Commencer à partir de",
  search_in_id: "Rechercher dans l'ID",
  filter_user: "Filtre utilisateur",
  clear_filters: "Effacer les filtres",
  send_sms: "Envoyer SMS",
  selected_pattern: "Modèle sélectionné",
  send: "Envoyer",
  bulk_download: "Téléchargement en masse",
  one_month_renewal: "Renouvellement mensuel",
  three_month_renewal: "Renouvellement trimestriel",
  six_month_renewal: "Renouvellement semestriel",
  one_year_renewal: "Renouvellement annuel",
  no_item_selected: "Aucun élément sélectionné !",
  error_loading_card_info:
    "Erreur de chargement des informations de la carte !",
  send_registered_successfully: "Envoi enregistré avec succès",
  error_getting_prices: "Erreur d'obtention des prix !",
  payment_error: "Erreur de paiement !",
  business_card: "Carte de visite",
  product_label: "Étiquette de produit",
  restaurant_menu: "Menu de restaurant",
  event_ticket: "Billet d'événement",
  brochure: "Brochure",
  flyer: "Flyer",
  poster: "Affiche",
  catalog: "Catalogue",
  newsletter: "Bulletin d'information",
  organization_name_hint: "Entrez le nom de votre organisation.",
  organization_name_label: "Nom de l'organisation",
  sub_organization_hint: "Entrez le nom de la sous-organisation.",
  sub_organization_label: "Description du nom de la sous-organisation",
  user_name_hint: "Entrez votre nom.",
  user_name_label: "Nom et prénom",
  work_field_hint: "Entrez votre poste.",
  work_field_label: "Poste",
  mobile_number_hint: "Entrez votre numéro.",
  mobile_number_label: "Numéro de mobile",
  phone_number_hint: "Entrez le numéro de téléphone.",
  phone_number_label: "Numéro de téléphone",
  email_hint: "Entrez votre e-mail.",
  email_label: "E-mail",
  fax_hint: "Entrez le fax de l'entreprise.",
  fax_label: "Fax de l'entreprise",
  website_hint: "Entrez le site web de l'entreprise.",
  website_label: "Site web de l'entreprise",
  postal_code_hint: "Entrez le code postal.",
  postal_code_label: "Code postal",
  copyright_hint: "Entrez le texte de copyright dans le pied de page.",
  copyright_label: "Texte de copyright",
  address_hint: "Entrez votre adresse.",
  address_label: "Adresse",
  add_more_info: "Ajoutez plus d'informations que vous souhaitez :",
  edit_location: "Modifier",
  add_location: "Ajouter",
  delete_location: "Supprimer l'emplacement",
  about_us_label: "À propos de nous",
  search_address: "Rechercher l'adresse :",
  northern_coordinates: "Coordonnées nord",
  eastern_coordinates: "Coordonnées est",
  select_address_on_map: "Sélectionner l'adresse sur la carte",
  location_not_found: "Emplacement non trouvé.",
  text_label: "Texte",
  number_label: "Numéro",
  website_address_label: "Adresse du site web",
  location_label: "Emplacement",
  mobile_viewer_title: "Visionneuse mobile",
  visit_theme_two_title: "Thème de carte de visite 2",
  visit_theme_flipped_title: "Thème de carte de visite retourné",
  flip_card: "Retourner la carte",
  flip_card_description: "Pour voir plus d'informations, retournez la carte",
  share_contacts: "Partager les contacts",
  close_share: "Fermer le partage",
  card_front: "Avant de la carte",
  card_back: "Arrière de la carte",
  flip_to_back: "Retourner vers l'arrière",
  flip_to_front: "Retourner vers l'avant",
  swipe_to_flip: "Glisser pour retourner",
  swipe_left: "Glisser à gauche",
  swipe_right: "Glisser à droite",
  expand_card: "Agrandir la carte",
  contract_card: "Réduire la carte",
  view_details: "Voir les détails",
  hide_details: "Masquer les détails",
  social_media_share: "Partage sur les réseaux sociaux",
  contact_actions: "Actions de contact",
  card_actions: "Actions de carte",
  floating_menu: "Menu flottant",
  close_menu: "Fermer le menu",
  open_menu: "Ouvrir le menu",
  choice_gallery: "Galerie sélectionnée",
  choice_video: "Sélectionner la vidéo",
  url_video: "Lien vidéo",
  selected_video: "Vidéo sélectionnée",
  add_video: "Ajouter une vidéo",
  edit_video: "Modifier la vidéo",
  linl_video: "Lien de transfert",
  upload_video: "Télécharger la vidéo",
  rule_link: "Le domaine doit être https://terminalads.com ou terminalads.com.",
  fax_hint: "Entrez le fax de l'entreprise.",
  fax_label: "Fax de l'entreprise",
  website_hint: "Entrez le site web de l'entreprise.",
  website_label: "Site web de l'entreprise",
  postal_code_hint: "Entrez le code postal.",
  postal_code_label: "Code postal",
  add_more_info: "Ajoutez plus d'informations que vous souhaitez :",
  address_hint: "Entrez votre adresse.",
  address_label: "Adresse",
  edit_location: "Modifier",
  add_location: "Ajouter",
  delete_location: "Supprimer l'emplacement",
  location_label: "Emplacement",
  about_company_label: "À propos de l'entreprise",
  select_address_on_map: "Sélectionner l'adresse sur la carte",
  search_address: "Rechercher l'adresse :",
  rule_link: "Le domaine doit être https://terminalads.com ou terminalads.com.",
  link_label: "Adresse du lien",
  label_label: "Étiquette",
  field_value_label: "Valeur du champ",
  add_new_field: "Ajouter un nouveau champ",
  tehran_address:
    "Téhéran, rue Shariati, après le pont Seyed Khandan, ruelle Khandan, n° 6",
  welcome_message_hint:
    "Si activé, le client recevra un message de bienvenue lors de son adhésion au club.",
  change_pattern_campaign: "Changer le modèle/campagne",
  selected_message: "Message sélectionné :",
  required_inputs: "Entrées requises :",
  selected_campaign_or_pattern: "Campagne/modèle sélectionné :",
  campaign: "Campagne",
  pattern: "Modèle",
  id: "ID",
  auto_csv_download_label: "Enregistrement automatique",
  auto_csv_download_hint:
    "Après l'ouverture de la carte, vos informations seront automatiquement téléchargées sur le mobile du client.",
  show_cclub_onload_label: "Suggestion d'adhésion",
  show_cclub_onload_hint:
    "Une fenêtre s'ouvrira pour rejoindre le club client.",
  forced_submission_hint:
    "Avec l'affichage du formulaire d'adhésion, le client doit enregistrer son numéro.",
  forced_submission_forced: "Adhésion forcée",
  forced_submission_optional: "Adhésion optionnelle",
  has_manifest_icons_label: "Personnalisation de l'application web",
  has_assistant_label: "Étiquette de l'assistant",
  select_assistant: "Sélectionner l'assistant",
  assistant_ai: "Assistant IA",
  has_manifest_icons_hint:
    "Le logo et l'image apparaîtront lorsque l'application web sera installée sur mobile ou ordinateur.",
  logo_144px: "Logo 144 px",
  logo_48px: "Logo 48 px",
  photo_wide: "Photo large",
  photo: "Photo",
  iranian_social_networks: "Réseaux sociaux iraniens",
  foreign_social_networks: "Réseaux sociaux étrangers",
  advertising_sites: "Sites publicitaires",
  other_links: "Autres liens",
  custom_text: "Texte personnalisé",
  custom_text_placeholder: "Entrez votre texte personnalisé.",
  aparat: "Aparat",
  aparat_hint: "Entrez le nom de votre chaîne sur Aparat",
  eitaa: "Eitaa",
  eitaa_hint: "Entrez votre nom d'utilisateur",
  soroush: "Soroush",
  soroush_hint: "Entrez votre nom d'utilisateur",
  bale: "Bale",
  bale_hint: "Entrez votre nom d'utilisateur",
  rubika: "Rubika",
  rubika_hint: "Entrez le lien de la chaîne/groupe",
  gap: "Gap",
  gap_hint: "Entrez votre nom d'utilisateur",
  linkedin: "Profil personnel LinkedIn",
  linkedin_hint: "Entrez votre nom d’utilisateur",
  linkedin_company: "Page d’entreprise LinkedIn",
  linkedin_company_hint: "Entrez le nom de votre page d’entreprise",
  pinterest: "Pinterest",
  pinterest_hint: "Entrez votre nom d'utilisateur",
  dribbble: "Dribbble",
  dribbble_hint: "Entrez votre nom d'utilisateur",
  facebook: "Facebook",
  facebook_hint: "Entrez votre nom d'utilisateur",
  github: "GitHub",
  github_hint: "Entrez votre nom d'utilisateur",
  threads: "Threads",
  threads_hint: "Entrez votre nom d'utilisateur",
  tiktok: "TikTok",
  tiktok_hint: "Entrez votre nom d'utilisateur",
  twitter: "Twitter",
  twitter_hint: "Entrez votre nom d'utilisateur",
  skype: "Skype",
  skype_hint: "Entrez votre nom d'utilisateur",
  youtube: "YouTube",
  youtube_hint: "Entrez votre nom d'utilisateur sans @",
  wechat: "WeChat",
  wechat_hint: "Entrez votre nom d'utilisateur",
  viber: "Viber",
  viber_hint: "Entrez votre nom d'utilisateur",
  divar: "Divar",
  divar_hint: "Entrez le lien de l'annonce/tableau/magasin",
  sheypoor: "Sheypoor",
  sheypoor_hint: "Entrez le lien de l'annonce/tableau/magasin",
  social_network: "Réseau social",
  photo_logo_tab: "Image/Logo",
  gallery_image_tab: "Galerie d'images",
  template_image: "Image de modèle",
  background_image: "Image de fond",
  upload_logo: "Télécharger le logo",
  welcome_image_upload: "Télécharger l'image/logo de bienvenue",
  welcome_photo: "Photo de bienvenue",
  loading_animation: "Animation de chargement",
  preview_welcome_page: "Aperçu de la page de bienvenue",
  default_template_image: "Image de fond de modèle par défaut",
  default_background_image: "Image de fond par défaut",
  default_logo: "Logo par défaut",
  default_welcome: "Bienvenue par défaut",
  default_gallery: "Galerie par défaut",
  animation_scale: "Échelle depuis le centre",
  animation_slide_x: "Glisser depuis la gauche",
  animation_slide_y: "Glisser depuis le haut",
  animation_fade: "Fondu",
  image_size_error: "Taille maximale par image de fond : 2 Mo.",
  logo_size_error: "Taille maximale par logo : 2 Mo.",
  categories: {
    bankcard: 'Carte bancaire',
    bale: "Bale",
    robika: "Robika",
    eitaa: "Eitaa",
    text: "Texte",
    multi_card: "Carte multiple",
    product_introduction_pro: "Présentation produit Pro",
  "gift": "Cadeau",
   electronic_business_card_pro: "Carte de visite électronique Pro",
    link_pro:"Link Pro",
    generated_images: "Images générées",
    electronic_business_card: "Carte de visite électronique",
    social_media: "Réseaux sociaux",
    photo_gallery: "Galerie photo",
    video_gallery: "Galerie vidéo",
    link: "Lien",
    audio_gallery: "Galerie audio",
    audio_gallery_pro: "Galerie audio (Pro)",
    feedback: "Retour d'information",
    consultation_form: "Formulaire de consultation",
    application: "Application",
    pdf_gallery: "Galerie PDF",
    schedule_table: "Tableau des horaires",
    personal_company_website: "Site web personnel/entreprise",
    online_store: "Boutique en ligne",
    online_menu: "Menu en ligne",
    appointment_booking: "Réservation de rendez-vous",
    commercial_admin_website: "Site web commercial/admin",
    online_insurance_sales: "Vente d'assurance en ligne",
    discount_code: "Code de réduction",
    product_introduction: "Présentation du produit",
    product_label: "Étiquette de produit",
    gold_label: "Étiquette or",
    franchise: "Franchise (Page d'affaires)",
    marketplace: "Marketplace (Page d'affaires)",
    recruitment_form: "Formulaire de recrutement",
    organizational_form: "Formulaire organisationnel",
    employee_card: "Carte d'employé",
    book_magazine: "Livre/Magazine",
    catalog_brochure: "Catalogue/Brochure",
    catalog: "Catalogue",
    faq: "FAQ",
    feedback_survey: "Retour d'information/Enquête",
    consultation_request: "Demande de consultation",
    customer_club: "Club client",
    invitation_card: "Carte d'invitation",
    countdown: "Compte à rebours",
    tombstone: "Pierre tombale",
  },
  support_day60: "Garantie de remboursement de 60 jours",
  "enter_visit_card_pro_info": "Entrez le nom de la carte de visite Pro",
  ROUTE: {
    TITLES: {
      QR_NAME_EDIT_TEXT: "Modifier le texte du QR",
       SERVER_DOWN: "Mise à jour en cours",
    CREATE_MEMORIES_MODEL: "Créer le modèle cadre de souvenirs",
    CREATE_CARD_VISIT_PRO_MODEL: "Créer le modèle carte de visite pro",
    CREATE_PRODUCT_PRO_MODEL: "Créer le modèle présentation produit pro",
    CREATE_PRODUCT_LABEL_MODEL: "Créer le modèle étiquette produit",
    CREATE_PHOTO_GALLERY_MODEL: "Créer le modèle galerie de photos",
    CREATE_PDF_GALLERY_MODEL: "Créer le modèle galerie PDF",
    CREATE_SOCIAL_MEDIA_MODEL: "Créer le modèle réseaux sociaux",
    EDIT_CARD_VISIT_PRO_MODEL: "Modifier le modèle carte de visite pro",
    EDIT_PRODUCT_PRO_MODEL: "Modifier le modèle présentation produit pro",
    EDIT_PRODUCT_LABEL_MODEL: "Modifier le modèle étiquette produit",
    EDIT_PHOTO_GALLERY_MODEL: "Modifier le modèle galerie de photos",
    EDIT_PDF_GALLERY_MODEL: "Modifier le modèle galerie PDF",
    EDIT_SOCIAL_MEDIA_MODEL: "Modifier le modèle réseaux sociaux",
    BOOK: "Livre",
    NFC_LIST: "Liste des NFC",
    API_KEY_MANAGER: "Créer une clé API",
    PRE_PURCHASE: "Pré-achat",
    PRE_PURCHASE_MODEL: "Modèle prêt",
      "QR_NAME_EDIT_GIFT": "Modifier le code QR du cadeau",
      "QR_GIFT": "Code QR du cadeau",
      "QR_NAME_EDIT_PRO": "Modifier le code QR du lien Pro",
      "QR_LINK_PRO": "QR Link Pro",
      DIGI: "Surveillance des prix Digikala",
      QR_PDF: "Galerie PDF",
      QR_NAME_EDIT_PDF: "Modifier la galerie PDF",
      QR_MULTICART: "QR Multi‑carte",
      QR_MULTICART_EDIT: "Modifier la QR Multi‑carte",
      QR_PRODUCTPRO: "Présentation du Product Pro",
      QR_NAME_PRODUCTPRO: "Modifier la présentation du Product Pro",
      QR_CATALOG: "Catalogue / Brochure",
      QR_NAME_EDIT_CATALOG: "Modifier le catalogue",
      QR_LUCK_WHEEL_Edit: "Modifier la roue de la chance",
      QR_LUCK_WHEEL: "Créer un QR code pour roue de la fortune",
      DASHBOARD: "Tableau de bord",
      ADMIN_QR_DOMAINS: "Surveillance des domaines",
      ADMIN_TOGETHER_TOKEN: "Surveillance des jetons",
      ADMIN_QR_SMS: "Envoi de SMS",
      MENU_PROFILE_INFO: "Informations utilisateur",
      MENU_PROFILE_SETTING: "Paramètres du profil",
      MENU_PROFILE_ORDERS: "Commandes",
      MENU_PROFILE_ADDRESSES: "Adresses",
      QR_MONITORING: "Surveillance QR",
      QR_LIST: "Liste de mes QR",
      QR_NAME_LIST: "Gestion de la participation",
      QR_GENERATE_MULTIPLE: "Création groupée de codes QR",
      QR_CARD_VISIT: "Créer une carte de visite",
      HELP_INFO: "Tester le bouton",
      QR_MENU: "Menu boutique",
      QR_APPOINTMENT: "Prise de rendez-vous",
      QR_INSURANCE: "Créer une assurance en ligne",
      QR_BPAGE: "Créer une page professionnelle",
      QR_CPAGE: "Créer un site pour complexe commercial/administratif",
      QR_BSHOP: "Boutique en ligne",
      QR_NAME_EDIT_BSHOP: "Modifier la boutique en ligne",
      QR_LINK_EDIT: "Modifier le lien",
      QR_NAME_DESIGN: "Modifier le design",
      QR_NAME_SETTING: "Modifier les paramètres",
      QR_NAME_EDIT: "Modifier la carte de visite",
      QR_NAME_EDIT_BPAGE: "Modifier la page professionnelle",
      QR_EDIT_CPAGE: "Modifier le site du complexe commercial/administratif",
      QR_NAME_INSURANCE: "Modifier l'assurance en ligne",
      QR_NAME_EDIT_MENU: "Modifier le menu",
      QR_NAME_EDIT_APPLICATION: "Fournir l'application",
      QR_NAME_EDIT_APPOINTMENT: "Modifier la prise de rendez-vous",
      QR_NAME_EDIT_PHOTO: "Modifier la galerie photo",
      QR_NAME_EDIT_VIDEO: "Modifier la galerie vidéo",
      QR_NAME_EDIT_VOICE: "Modifier la galerie audio",
      QR_NAME_EDIT_FEEDBACK: "Modifier la galerie de retours",
      QR_NAME_CONSULTATION_QR_EDIT: "Modifier le formulaire de demande",
      QR_NAME_EDIT_VOICE_PRO: "Modifier la galerie audio (Pro)",
      QR_NAME_EDIT_SOCIAL: "Modifier les réseaux sociaux",
      QR_NAME_STATISTICS: "Statistiques du code QR",
      QR_CATE: "Sélectionner la catégorie",
      QR_SHARE: "Partager",
      QR_BUSINESS_SHOP: "Entreprise/Boutique",
      QR_CO_ORGAN: "Société/Organisation",
      QR_CONTACT: "Contact client",
      QR_NOTICES: "Notifications",
      QR_OTHERS: "Divers",
      QR_STATICS: "QR statique",
      QR_DYNAMICS: "QR dynamique",
      QR_D_BUSINESS: "QR dynamique commercial",
      QR_D_ORGANS: "QR dynamique organisationnel",
      QR_D_GOVERNMENT: "QR dynamique gouvernemental",
      QR_VIDEO: "Galerie vidéo",
      QR_APPLICATION: "Fournir l'application",
      QR_VOICE: "Galerie audio",
      QR_VOICE_PRO: "Galerie audio (Pro)",
      QR_CONSULTATION_QR: "Formulaire de demande",
      QR_FEEDBACK: "Galerie de retours",
      QR_PHOTO: "Galerie photo",
      QR_LOCATION: "Créer un QR pour localisation",
      QR_SOCIAL_MEDIA: "Créer un QR pour réseaux sociaux",
      QR_LINK: "Créer un lien",
      QR_TEXT: "Créer un texte",
      QR_MAIL: "Créer un e-mail",
      QR_CALL: "Appel",
      QR_SMS: "SMS",
      QR_WHATSAPP: "WhatsApp",
      QR_SITE: "Site web",
      QR_INSTAGRAM: "Instagram",
      QR_SKYPE: "Skype",
      QR_WIFI: "Wi-Fi",
      QR_BUSINESS: "Page professionnelle",
      QR_DISCOUNT: "Page de remise",
      QR_PRODUCT_SHOP: "Présentation produit",
      QR_PRODUCT_LABEL: "Étiquette produit",
      QR_GOLD_LABEL: "Étiquette or",
      QR_PRODUCT_TEMPLATE: "Produits",
      ADMIN_CATEGORY: "Catégories",
      QR_NFC_ORDERS: "Cartes NFC en attente de confirmation",
      QR_NAME_PRODUCT: "Modifier la présentation produit",
      QR_NAME_LABELPRODUCT: "Modifier l'étiquette produit",
      QR_NAME_GOLDPRODUCT: "Modifier l'étiquette or",
      QR_COINS: "Cryptomonnaies",
      QR_SHOP: "Gestion boutique",
      QR_TWITTER: "Twitter",
      UPLOAD_CENTER: "Centre d'upload",
      PRICING: "Tarifs QR",
      QR_CREATE_MODELS: "Créer un modèle de carte de visite",
      QR_CREATE_BUSINESS_MODELS: "Créer un modèle de page professionnelle",
      QR_CREATE_PRODUCT_MODEL: "Créer un modèle de carte produit",
      QR_CREATE_MENU_MODELS: "Créer un modèle de menu boutique",
      QR_CREATE_SHOP_MODEL: "Créer un modèle de boutique en ligne",
      MODELS_LIST: "Types de modèles QR",
      MODELS_LIST_EDIT: "Modifier le modèle",
      MODELS_LIST_MENU_EDIT: "Modifier le modèle de menu",
      MODELS_LIST_BMODEL_EDIT: "Modifier le modèle de boutique en ligne",
      NFC: "Cartes NFC",
      SUBMIT_FORM: "Enregistrer le blogueur",
      REQUEST_LIST: "Liste des blogueurs",
      PURE_DATA: "Liste des cartes de visite non créées",
      AUTO_CREATE: "Création automatique de QR",
      QR_CREATE: "Créer un QR",
      HISTORY_REMINDER: "Surveillance des rappels",
      BOOK: "Surveillance des rappels"
    },
  },
  COMPONENTS: {
    QR_SHOP_MANAGER: {
      PAYMENT_METHODS: "Méthodes de paiement",
      ORDER_NOTIFICATIONS: "Notifications de commande",
      DISCOUNT_CODE: "Code de réduction",
      CART: "Panier",
      TABLE_MANAGEMENT: "Gestion des tables",
    },
    ERRORS: {
      INVALID_INPUT: "Veuillez saisir les valeurs correctement !",
      CART_SETTINGS_FAILED: "Les paramètres du panier ont échoué !",
    },
  },
  popup: {
    prepared_stores_title: "Exemples de boutiques en ligne prêtes",
  },
  buttons: {
    reset_defaults: "Réinitialiser les données par défaut",
    download_qr: "Télécharger le QR",
    cleardefaults: "Supprimer les informations par défaut",
    select_prepared_store: "Sélectionner une boutique en ligne prête",
  },
  stepper: {
    create_qr: "Créer un QR",
    products_info: "Produits et informations",
    content_settings: "Paramètres de contenu",
    sales_settings: "Paramètres de vente",
  },
  fields: {
    online_store_name: "Nom de la boutique en ligne",
    qr_address: "Adresse QR",
    qr_address_hint: "Saisissez votre adresse QR",
    online_sale: "Vente en ligne",
  },
  login_settings: "Paramètres de connexion",
  shop_logo_and_images: "Logo et images de la boutique",
  login_page_info: "Informations de la page de connexion",
  upload_banner: "Téléverser la bannière",
  create_product: "Créer un produit",
  special_sale: "Vente spéciale",
  ended: "Terminé",
  blog: "Blog",
  services: "Services",
  pdf_gallery: "Galerie PDF",
  create_section: "Créer une section",
  achievements: "Réalisations",
  team_members: "Membres de l'équipe",
  working_hours: "Heures de travail",
  saturday: "Samedi",
  sunday: "Dimanche",
  monday: "Lundi",
  tuesday: "Mardi",
  wednesday: "Mercredi",
  thursday: "Jeudi",
  friday: "Vendredi",
  we_will_be_different: "Nous serons différents...",
  striving_for_excellence:
    "Nous nous efforçons toujours d’être les meilleurs >>> pour vous",
  online_store_ready_15_minutes:
    "Votre boutique en ligne est prête en 15 minutes !",
  sales_management: "Gestion des ventes",
  dear_customer_online_stores:
    "Cher client, vous pouvez aussi acheter dans nos autres boutiques en ligne :",
  divar_site: "Site Divar",
  digikala_site: "Site Digikala",
  basalam_site: "Site Basalam",
  torob_site: "Site Torob",
  emalls_site: "Site Emalls",
  copyright_qrland: "Tous droits réservés à QR Land.",
  tehran_address:
    "Téhéran, rue Shariati, après le pont Seyed Khandan, impasse Khandan, n°6",
  our_achievements: "Nos réalisations",
  customer_satisfaction: "Satisfaction client",
  lowest_returns: "Moins de retours",
  loyal_customer: "Client fidèle",
  shipped_orders: "Commandes expédiées",
  visit_our_videos: "Visitez nos vidéos.",
  bringing_the_best: "Nous vous apportons le meilleur...",
  feedback_important: "Votre avis nous importe",
  guide_us_with_feedback:
    "Veuillez nous guider en répondant aux questions ci-dessous pour améliorer nos services.",
  satisfied_with_quality: "Êtes-vous satisfait de la qualité des produits ?",
  evaluate_packaging_quality:
    "Comment évaluez-vous la qualité de l'emballage ?",
  satisfied_with_variety: "Êtes-vous satisfait de la variété des produits ?",
  benefited_from_discounts:
    "Avez-vous bénéficié des réductions de cette boutique ?",
  post_1: "Post 1",
  fast_order_delivery: "Livraison rapide de commande",
  post_2: "Post 2",
  post_3: "Post 3",
  product_authenticity_guarantee: "Garantie d'authenticité du produit",
  comfortable_purchase: "Un achat confortable",
  how_to_place_order: "Comment passer une commande ?",
  add_to_cart: "Ajoutez simplement les produits souhaités au panier.",
  how_to_register: "Comment s'inscrire sur le site ?",
  click_login_and_enter_code:
    "Cliquez sur le bouton « Connexion », entrez votre numéro de mobile et le code reçu par SMS.",
  delivery_time:
    "Combien de temps faut-il pour recevoir ma commande après enregistrement ?",
  fastest_delivery: "Votre commande sera expédiée le plus rapidement possible.",
  shipping_cost: "Quel est le coût de livraison ?",
  shipping_cost_order: "Coût de livraison de la commande",
  variable_shipping_cost: "Le coût de livraison varie selon votre adresse.",
  change_or_cancel_order:
    "Puis-je modifier ou annuler ma commande après enregistrement ?",
  no_change_or_cancel: "Non. Aucune modification ou annulation n'est possible.",
  mrs_Safdarian: "Mme Safdarian",
  invalid_address: "L'adresse saisie est incorrecte !",
  shop_page_created_success: "Votre page boutique a été créée avec succès.",
  qr_creation_failed: "Échec de la création du QR !",
  server_error: "Erreur serveur !",
  qr_card_updated_success: "Votre carte de visite a été modifiée avec succès.",
  qr_save_edit_failed: "Erreur lors de la sauvegarde/modification du QR",
  your_feedback: "Votre avis",
  digital_marketing_strategy:
    "Placez votre entreprise sur la bonne voie avec notre stratège en marketing numérique",
  wait_for_default_products:
    "Veuillez patienter jusqu'à ce que les produits par défaut soient entièrement chargés sur votre site.",
  template_categories_saved: "Catégories de modèle enregistrées avec succès.",
  template_products_saved: "Produits de modèle enregistrés avec succès.",
  template_products_save_failed:
    "Erreur lors de l'enregistrement des produits de modèle !",
  template_categories_save_failed:
    "Erreur lors de l'enregistrement des catégories de modèle !",
  login_page_text: "Texte de la page de connexion",
  persian_error: "Le texte doit être en persan",
  number_error:
    "Les données saisies ne doivent pas être non numériques ou vides",
  english_error: "Le texte ne doit pas être non anglais ou vide",
  mixPerEng_error:
    "Le texte ne doit pas être non anglais ou non persan ou vide",
  email_error: "Le format de l'e-mail saisi est incorrect",
  mobile_error: "Le format du numéro saisi est incorrect",
  meliCode_error: "Le format du code national saisi est incorrect",
  site_error: "Le format du site saisi est incorrect",
  min_length_error: "La valeur saisie ne peut pas être inférieure à {{min}}",
  max_length_error: "La valeur saisie ne peut pas être supérieure à {{max}}",
  form_submitted_message: "Votre formulaire a été envoyé avec succès",
  required_fields_error: "Les valeurs obligatoires n'ont pas été saisies",
  headphone_title: "Casque audio",
  buy_button: "Acheter",
  day: "jour",
  hour: "heure",
  minute: "minute",
  second: "seconde",
  required_field_error: "{{fieldName}} est obligatoire",
  submit_request_button: "Soumettre la demande",
  request_submitted_success: "Votre demande a été enregistrée avec succès",
  feedback_submitted_success: "Votre avis a été enregistré avec succès",
  description_required_label: "Description (obligatoire)",
  description_optional_label: "Description (facultative)",
  description_hint:
    "Veuillez saisir la description souhaitée dans ce champ (au moins 3 caractères)",
  footer: {
    position: "Côté",
    contactUs: "Contactez-nous",
    aboutUs: "À propos de nous",
    firstShift: "Premier quart",
    secondShift: "Deuxième quart",
    startTime: "Heure de début",
    endTime: "Heure de fin",
    features: "Fonctionnalités",
    partners: "Partenaires",
    affiliates: "Programmes affiliés",
    panels: "Panneaux",
    supportTicket: "Ticket de support",
    inPersonServices: "Services en personne",
    liveChat: "Chat en direct",
    faq: "FAQ",
    add_secondshift: "Ajouter un deuxième quart",
    firstDate: "Date de début",
    endDate: "Date de fin",
  },
  qr_management: "Gestion QR",
  restore_default_questions: "Restaurer les questions par défaut",
  delete_all: "Tout supprimer",
  edit_question: "Modifier la question",
  move_up: "Monter",
  move_down: "Descendre",
  delete: "Supprimer",
  selected_question: "Question sélectionnée",
  question: "Question",
  answer_type: "Type de réponse",
  excellent: "Excellent",
  good: "Bien",
  very_poor: "Très faible",
  response_optionality: "Réponse facultative / obligatoire",
  required: "Obligatoire",
  optional: "Facultatif",
  add_new_question: "Ajouter une nouvelle question",
  satisfied_with_quality: "Êtes-vous satisfait de la qualité des produits ?",
  evaluate_packaging_quality:
    "Comment évaluez-vous la qualité de l'emballage ?",
  satisfied_with_variety: "Êtes-vous satisfait de la variété des produits ?",
  benefited_from_discounts:
    "Avez-vous bénéficié des réductions de cette boutique ?",
  suggestions_for_improvement:
    "Quel est votre conseil pour améliorer l'expérience d'achat dans cette boutique ?",
  confirm_delete_question: "Supprimer la question sélectionnée ?",
  question_deleted_success: "Question supprimée avec succès.",
  question_delete_failed: "Erreur lors de la suppression de la question !",
  confirm_delete_all_questions:
    "Êtes-vous sûr de vouloir supprimer toutes les questions ?",
  questions_deleted_success: "Questions supprimées avec succès.",
  questions_delete_failed: "Erreur lors de la suppression des questions !",
  invalid_input: "Veuillez saisir les valeurs correctement !",
  operation_failed: "L'opération a échoué !",
  question_number: "Question {number} ?",
  card_subtitle:
    "Saisissez simplement l'histoire de l'image souhaitée, l'IA la créera pour vous.",
  upgrade_label: "Joindre",
  free: " - Gratuit",
  language_select: "Sélectionner la langue pour écrire le texte de la demande",
  image_size: "Taille de l'image",
  prompt_label: "Texte de la demande",
  prompt_placeholder: "Décrivez l'image souhaitée...",
  generate_image: "Générer l'image",
  regenerate_image: "Générer une nouvelle image",
  save_image: "Enregistrer l'image",
  save_image_subtitle: "Seule l'image affichée ci-dessus sera enregistrée.",
  size_items: {
    "16:9": "16:9 (horizontal)",
    "9:16": "9:16 (vertical)",
    "1:1": "1:1 (carré)",
  },
  lang_items: {
    fa: "Fa | Persan",
    en: "En | Anglais",
    ar: "Ar | Arabe",
  },
  rules: {
    empty: "Au moins 3 caractères doivent être saisis !",
    spell_checker: "Le texte saisi doit être en {language} !",
  },
  ERRORS: {
    VpnDetectedTitle: "Désactivez votre VPN",
    VpnDetectedSubtitle:
      "Cela aide le système à fonctionner mieux et vous offre une meilleure expérience.",
  },
  errors: {
    VpnDetectedTitle: "Désactivez votre VPN",
    VpnDetectedSubtitle:
      "Cela aide le système à fonctionner mieux et vous offre une meilleure expérience.",
    invalid_size: "Veuillez saisir la largeur et la hauteur correctement !",
    image_generation_error: "Erreur lors de la génération de l'image",
    image_upload_error: "Erreur lors du téléversement de l'image !",
    service_unavailable:
      "Ce service n’est pas disponible – le chargement des données depuis le serveur a échoué",
    qr_address_taken: "Cette adresse QR est déjà utilisée",
  },
  add_working_time: "Ajouter un horaire de travail",
  selected_day: "Jour sélectionné",
  range_name: "Nom de la plage horaire",
  add: "Ajouter",
  first_shift: "Premier quart",
  second_shift: "Deuxième quart",
  start_time: "Heure de début",
  end_time: "Heure de fin",
  date_range: "Plage de dates",
  all_week_days: "Tous les jours de la semaine",
  saturday_to_wednesday: "Samedi à mercredi",
  saturday_to_thursday: "Samedi à jeudi",
  work_week: "Tous les jours de la semaine (sauf jours fériés)",
  feedbacks: "Retours",
  failed_retrieve_feedback: "Échec de la récupération des retours !",
  province: "Province",
  search_city_placeholder: "Recherchez le nom de la ville souhaitée.",
  search_city_label: "Recherche de ville",
  welcome: "Bienvenue dans notre application",
  description: "Ceci est une application multilingue.",
  soon: "Bientôt",
  beta_version: "Version bêta",
  defaults_cleared_success: "Données par défaut supprimées avec succès",
  defaults_reset_success: "Données par défaut réinitialisées avec succès",
  select_navigator_after_location_click:
    "Après avoir cliqué sur le lieu, sélectionnez le navigateur souhaité",
  no_address_selected: "Aucune adresse sélectionnée",
  no_location_selected: "Aucun emplacement sélectionné",
  region: "Région",
  api_unauthorized: "Erreur d'authentification : Clé API invalide",
  location_not_found: "Emplacement non trouvé",
  addCategory: "Ajouter une nouvelle catégorie",
  editCategory: "Modifier la catégorie",
  deleteCategory: "Supprimer la catégorie sélectionnée ?",
  addProduct: "Ajouter un nouveau produit",
  saveProducts: "Sélectionner les produits par défaut",
  addSubCategory: "Ajouter une sous-catégorie",
  product: "Produit",
  categoryName: "Nom de la catégorie",
  subCategoryName: "Nom de la sous-catégorie",
  confirmDeleteProduct: "Le produit doit-il être supprimé de la catégorie ?",
  successMessages: {
    categorySaved: "Catégories enregistrées avec succès.",
    productSaved: "Produits enregistrés avec succès.",
    productDeleted: "Produit supprimé avec succès.",
  },
  errorMessages: {
    saveCategoryFailed: "Erreur lors de l'enregistrement des catégories !",
    saveProductFailed: "Erreur lors de l'enregistrement des produits !",
    deleteCategoryFailed: "Erreur lors de la suppression de la catégorie !",
  },
  add_edit_categories: "Ajouter/modifier une catégorie",
  copy_category: "Copier la catégorie",
  product: "Produit {point}",
  copy_product: "Copier le produit",
  add_edit_products: "Ajouter/modifier des produits",
  edit_category: "Modifier la catégorie",
  category_name: "Nom de la catégorie",
  edit_subcategory: "Modifier la sous-catégorie",
  subcategory_name: "Nom de la sous-catégorie",
  add_new_category: "Ajouter une nouvelle catégorie",
  store_management: "Gestion de la boutique",
  manage_products: "Gestion des produits",
  products_export: "Télécharger les produits",
  "UPLOAD_EXCEL.UPLOAD_TITLE": "Télécharger un fichier Excel",
  "UPLOAD_EXCEL.DRAG_DROP_TEXT_PART1": "Glissez votre fichier Excel ici ou",
  "UPLOAD_EXCEL.DRAG_DROP_TEXT_PART2": "sélectionnez-le",
  "UPLOAD_EXCEL.DRAG_DROP_TEXT_PART3": "pour télécharger",
  "UPLOAD_EXCEL.INVALID_FILE_TYPE":
    "Veuillez télécharger uniquement des fichiers Excel (.xlsx)",
  "GENERAL.SUBMIT": "Soumettre",
  "GENERAL.CANCEL": "Annuler",
  "GENERAL.SUCCESSFULLY_ADDED": "Produits téléchargés avec succès",
  SUCCESSFULLY_DOWNLOADED: "Produits téléchargés avec succès",
  "GENERAL.ERROR": "Une erreur s'est produite",
  EditSubCategoty: "Modifier la sous-catégorie",
  create: "Créer",
  save_changes: "Enregistrer les modifications",
  buy_button_settings: "Paramètres du bouton d'achat",
  image: "Image",
  color: "Couleur",
  title: "Titre",
  price: "Prix",
  discount: "Remise",
  percent: "Pourcent",
  amount: "Montant",
  brand: "Marque",
  inventory: "Stock",
  inventory_hint: "Laisser vide = quantité de commande illimitée",
  order_limit: "Quantité max. par commande",
  order_limit_hint: "Laisser vide = aucune limite",
  packing_price: "Frais d'emballage",
  packing_price_hint:
    "Appliqué pour les commandes externes (courrier/ramassage sur place).",
  description: "Description",
  options: "Options",
  product_features: "Caractéristiques du produit",
  field_required: "Champ obligatoire.",
  min_length: "Au moins 3 caractères requis.",
  product: "Produit",
  default_brand: "Apple",
  product_added_success: "Produit ajouté avec succès",
  product_added_error: "Erreur lors de l'ajout du produit",
  whole_categories: "(Toutes les catégories)",
  add_select_category: "Ajouter/sélectionner une catégorie",
  select_default_category: "Sélectionner la catégorie par défaut",
  deleted_product: "Supprimer le produit",
  confirm_delete_prooduct: "Le produit doit-il être supprimé de la catégorie ?",
  please_wait_store_product:
    "Les produits sont en cours d'enregistrement, veuillez patienter...",
  saved_product_success: "Produits enregistrés avec succès.",
  error_in_store: "Erreur d'enregistrement",
  delete_category: "Supprimer la catégorie",
  confirm_delete_category: "Catégorie supprimée avec succès.",
  error_delete_category: "Erreur lors de la suppression de la catégorie !",
  productOptionEditor: {
    tabs: {
      color: "Couleur",
      size: "Taille",
      count: "Quantité",
      weight: "Poids",
      type: "Type/Genre",
    },
    fields: {
      count: "Quantité",
      max_order: "Quantité max. par commande",
      price: "Prix",
      discount: "Remise",
      color: "Couleur",
      color_name: "Nom de la couleur",
      inventory: "Stock",
      size: "Taille",
      type: "Type/Genre",
      weight: "Poids",
    },
    actions: {
      delete: "Supprimer",
      add_location: "Ajouter une option",
    },
  },
  extraSubProducts: {
    feature: "Caractéristique",
    name_label: "Nom",
    name_placeholder: "Exemple : Sauce supplémentaire / Pain supplémentaire",
    price_label: "Prix",
    price_hint: "Laisser vide = ajout gratuit.",
    price_placeholder: "Exemple : Eau, Type (ex. poitrine de poulet/cuisse)",
    add_subproduct: "Ajouter un produit complémentaire",
  },
  error_selected_category: "Erreur lors de la sélection de la catégorie !",
  suggestinput: {
    title: "Sélectionner un emoji",
    aboutUs: "À propos de nous",
    error: "Erreur",
    errorMessage: "Veuillez recharger votre crédit et réessayer.",
    generateText: "Suggestion de texte IA",
    emoji: "Emoji",
    errorMessage_400:
      "Erreur lors de la création du texte 'À propos de nous'. Veuillez réessayer.",
    errorMessage_403:
      "Erreur lors de la création du texte 'À propos de nous'. Achetez un forfait et réessayez",
  },
  togetherai: {
    buy_package: "Acheter un forfait",
    tax_notice: "10 % de TVA seront ajoutés au prix du forfait !",
    package: "Forfait",
    rial: "Rial",
    buy_button: "Acheter !",
    discount_label: "Code de réduction",
    submit_discount: "Utiliser",
    success_message: "Votre QR a été mis à niveau avec succès.",
    error_insufficient_funds: "Vérifiez votre crédit et réessayez plus tard.",
    error_upgrade: "Erreur lors de la mise à niveau du QR !",
    error_title: "Erreur",
    success_title: "Succès",
  },
  category_not_found: "Catégorie non trouvée !",
  create_upload_category: "Créer et télécharger une catégorie",
  add_subcategory: "Ajouter une sous-catégorie",
  error_upload_m_video:
    "Erreur lors du téléchargement de la vidéo (accès peut-être restreint).",
  info_show_video: "Cliquez sur 'Plus' pour afficher plus.",
  error_not_valid_guide_id: "ID de guide invalide !",
  error_give_guide_info:
    "Erreur lors de la récupération des informations du guide !",
  info_success_saved: "Enregistré avec succès",
  error_add_new_guide: "Erreur lors de l'ajout d'un nouveau guide",
  popup: {
    details: "Détails",
    guide_images: "Images du guide",
    guide_videos: "Vidéos du guide",
    faq: "FAQ",
    no_title: "Aucun titre",
    no_content: "Aucun contenu à afficher",
    no_questions: "Aucune question à afficher",
    video_error:
      "Erreur lors du téléchargement de la vidéo (accès peut-être restreint)",
    no_answer: "Aucune réponse",
    question_no_title: "Question sans titre",
    default_title: "Guide",
  },
  productPicker: {
    select_default_product: "Sélectionner le produit par défaut",
    search: "Rechercher",
    select_all_products: "Sélectionner tous les produits",
    back: "Retour",
    no_products_in_category: "Aucun produit dans cette catégorie !",
    products_error: "Erreur lors du chargement des produits !",
    retry: "Réessayer",
    items_per_page: "Éléments par page",
    root_breadcrumb: "/",
  },
  end_date: "Date de fin",
  filters: {
    userType: {
      legal: "Entité légale",
      individual: "Particulier",
    },
    serviceType: {
      Payamakland: "Payamakland",
      Coreland: "Coreland",
      Qrland: "Qrland",
      Robotland: "Robotland",
      billboard: "Billboard",
      tablighNegar: "TablighNegar",
      unknown: "Inconnu",
    },
    qrType: {
        gift: "Cadre de souvenirs",
        instagram: "Instagram",
        visitCard: "Carte de visite",
        Business: "Personnel / Entreprise",
        Commericial: "Site web d'un complexe commercial / administratif",
        qrlink: "Lien QR",
        labelproduct: "Étiquette produit",
        goldLabel: "Étiquette or",
        bShop: "Boutique",
        SocialMedia: "Réseaux sociaux",
        VideoGallery: "Galerie vidéo",
        PhotoGallery: "Galerie photo",
        voiceGallery: "Galerie audio",
        consultationQr: "Formulaire de demande",
        application: "Application",
        feedbackGallery: "Avis et retours",
        voiceGalleryPro: "Galerie audio professionnelle",
        singleProduct: "Présentation du produit",
        menu: "Menu",
        appointment: "Prise de rendez-vous",
        insurance: "Assurance",
        text: "Texte",
        luck_wheel: "Roue de la chance",
        pdfgallery: "Galerie PDF",
        productpro: "Présentation produit Pro",
        multicard: "Multi-carte",
        catalog: "Catalogue",
        visitCard_pro: "Carte de visite Pro",
        clickyarseo: "ClickYar SEO QR",
    },
    expire: {
      day: "Jour",
      expired: "Expiré",
    },
    numericPersianNumber: {
      thousand: "Mille",
      million: "Million",
    },
    dateString: {
      at: "à",
    },
    messages: {
      pleaseLogin: "Veuillez vous connecter",
      invalidPhone: "Numéro de téléphone invalide",
      copied: "Copié",
    },
  },
  nextButton: "Suivant",
  previousButton: "Précédent",
  rowsPerPageText: "Lignes par page",
  noDataText: "Aucune donnée à afficher",
  placeholderSearch: "Rechercher..",
  set_qr: "QR enregistré",
  numbers: "Nombres",
  enter_param_product: "Entrez les données du produit correctement !",
  instagram_hint: "Entrez votre Instagram",
  whatsapp_hint: "Entrez votre WhatsApp",
  telegram: "Telegram",
  telegram_hint: "Entrez votre Telegram",
  userpicker: {
    select_user: "Sélectionner un utilisateur",
    choice_users: "Sélectionner des utilisateurs",
    id: "ID",
    phone_number: "Numéro de mobile",
    date_created: "Date de création",
    info_edit: "Modifier les informations",
    name_family: "Prénom et nom de famille",
    position: "Poste et grade",
    phone: "Numéro de téléphone",
    discription: "Description",
  },
  search_product: "Rechercher un produit",
  search_name_product: "Rechercher le nom du produit",
  currency: "Rial",
  headers: {
    index: "Ordre",
    gallery: "Image",
    id: "ID",
    name: "Nom",
    brand: "Marque",
    price: "Montant",
    discount_amount: "Remise",
  },
  search_categories: "Rechercher dans les catégories",
  delete_all: "Tout supprimer",
  select_category: "Sélectionner une catégorie",
  currency1: "Rial iranien",
  features: "Caractéristiques",
  product_sp: {
    edit: "Modifier",
    back: "Retour",
    save: "Enregistrer",
    add_product_to_special_category:
      "Remplissez les champs pour ajouter le produit à la catégorie spéciale",
    inventory: "Stock",
    discount: "Remise",
    max_per_customer: "Max. par client",
    max_per_order: "Max. par commande",
    expires_at: "Date d'expiration",
    field_cannot_be_empty: "Le champ ne peut pas être vide.",
    please_enter_correctly: "Veuillez remplir correctement !",
    currency: "Rial iranien",
  },
  selectproduct: "Sélectionner un produit",
  section: {
    edit_part: "Modifier la section",
    title: "Titre",
    position_text: "Position du texte",
    add_video: "Ajouter une vidéo",
    text: "Texte",
    address_video: "URL de la vidéo",
    position_left: "Gauche",
    position_right: "Droite",
    tab_edit_button: "Bouton de modification",
    tab_content: "Contenu de la section",
  },
  name_shopping: "Nom de la boutique",
  hint_shopping: "Entrez le nom de votre boutique.",
  title_discount: "Titre de la remise",
  hint_discount: "Entrez le titre de votre remise.",
  hint_mount_discount: "20 % de remise sur votre prochaine commande.",
  label_discount: "Entrez le montant de la remise",
  give_discount: "Obtenir un code de réduction",
  give_copon: "Obtenir un bon",
  enter_copon: "Entrez le bon",
  hint_phone: "Entrez votre numéro de téléphone.",
  label_phone: "Numéro de téléphone",
  hint_condition_discount: "Décrivez les conditions de la remise..",
  label_discription_discount: "Description de la remise",
  add_info_discount: "Ajouter des informations supplémentaires :",
  enter_address_discount: "Entrez votre adresse.",
  address_discount: "Adresse",
  edit_feedback: "Modifier le retour",
  select_type_replay: "Sélectionner le type de réponse",
  field_discription: "Champ de description",
  messages_discription:
    "Activez ceci pour afficher un champ de description pour l'utilisateur",
  number_char: "Le nombre de caractères doit être entre 3 et 50 !",
  search: "Rechercher",
  no_videos_found: "Aucune vidéo trouvée !",
  upload_video_prompt:
    "Utilisez la zone de téléchargement de vidéo pour ajouter un fichier",
  delete_success: "Supprimé avec succès.",
  tabs: {
    qr_view: "Vue QR",
    preview: "Aperçu",
    ready_video: "Vidéo prête",
    video_gallery: "Galerie vidéo",
    link: "Lien",
    video_upload: "Télécharger une vidéo",
  },
  consultation: {
    name: "Prénom",
    surname: "Nom de famille",
    phone: "Numéro de mobile",
    nationalId: "Numéro d'identification nationale",
    nationalIdAuthenticate: "Vérifier le numéro d'identification nationale",
    nationalIdCorrect:
      "Vérifier la validité du numéro d'identification nationale",
    mail: "Email",
    address: "Adresse",
    location: "Emplacement",
    custom: "Personnalisé",
    customLabel: "Titre",
    customOptions: "Options",
    optional: "Optionnel",
    require: "Obligatoire",
    description: "Description",
  },
  add_section: "Ajouter une section",
  add_new_text_section:
    "Vous êtes chaleureusement invités au pays numérique intelligent de QR-Land.",
  btn_title_section: "Inscription gratuite",
  shop: {
    step_products_and_info: "Produits & informations",
    online_store_name: "Nom de la boutique en ligne",
    qr_address: "Adresse QR",
    qr_address_hint: "Entrez votre adresse QR",
    online_sale: "Vente en ligne",
    step_content_settings: "Paramètres de contenu",
    step_sale_settings: "Paramètres de vente",
    download_qr: "Télécharger le QR",
    login_settings: "Paramètres de connexion",
    store_logo_images: "Logo et images de la boutique",
    login_page_info: "Informations de la page de connexion",
    upload_banner: "Télécharger une bannière",
    user_info: "Informations utilisateur",
    create_product: "Créer un produit",
    special_sale: "Vente spéciale",
    add_social_media: "Ajouter des réseaux sociaux",
    blog: "Blog",
    services: "Services",
    faq: "FAQ",
    photo_gallery: "Galerie photo",
    video_gallery: "Galerie vidéo",
    pdf_gallery: "Galerie PDF",
    feedback: "Retour",
    countdown: "Compte à rebours",
    request_form: "Formulaire de demande",
    create_section: "Créer une section",
    achievements: "Réalisations",
    team_members: "Membres de l'équipe",
    working_hours: "Heures d'ouverture",
    error_saving_content:
      "Erreur lors de l'enregistrement des paramètres de contenu !",
    success_edit_store: "Page de la boutique modifiée avec succès.",
    post_1: "Publication 1",
    logo: "Logo",
    background_image: "Image de fond",
  },
  discount_obj: {
    quantity: "quantité",
    create_edit_code: "Créer/modifier un code de réduction",
    coding_type_label: "Type de création",
    coding_type_single: "Unique",
    coding_type_group: "Groupe",
    status_label: "Statut",
    status_active: "Actif",
    status_deactivate: "Désactivé",
    discount_code: "Code de réduction",
    discount_type: "Type de remise",
    discount_type_percent: "Pourcentage",
    discount_type_fixed: "Montant fixe",
    discount_value: "Valeur de la remise",
    discount_limit: "Limite de remise",
    no_limit: "Aucune limite",
    tab_create_discount: "Créer un code de réduction",
    tab_settings: "Paramètres",
    success_create: "Code de réduction créé avec succès",
    success_edit: "Code de réduction modifié avec succès",
    error_value_empty: "La valeur de la remise ne peut pas être vide !",
    error_start_time: "Aucune heure de début sélectionnée !",
    error_end_time: "Aucune heure de fin sélectionnée !",
    error_same_time:
      "Les heures de début et de fin ne peuvent pas être identiques",
  },
  personnel: {
    team_members: "Membres de l'équipe sélectionnés",
    add_team_member: "Ajouter un membre d'équipe",
    default_position: "Poste et grade",
    default_phone: "Numéro de téléphone",
    default_full_name: "Nom complet",
    default_description:
      "Lorem Ipsum est simplement un texte factice de l'industrie de l'impression, utilisé par les concepteurs depuis des siècles",
  },
  discount_settings: {
    function_type: {
      title: "Fonction de remise",
      all_shopping_cart: "Montant total du panier",
      special_products: "Produits spéciaux",
      special_categories: "Catégories spéciales",
    },
    basket_condition: {
      title: "Conditions du panier",
      no_conditions: "Aucune condition",
      minimum_shopping: "Montant minimum du panier",
      minimum_product: "Produits minimum dans le panier",
      maximum_shopping: "Montant maximum du panier",
      maximum_product: "Produits maximum dans le panier",
    },
    user_settings: {
      title: "Paramètres utilisateur",
      all_user: "Tous les utilisateurs",
      group: "Groupe d'utilisateurs",
      special: "Utilisateurs spéciaux",
    },
    limitation_use: {
      title: "Limitation d'utilisation",
      no_limitations: "Aucune limitation",
      discount_code: "Nombre d'utilisations du code de réduction",
      user: "Utilisations par utilisateur",
    },
    start_time: {
      title: "Date de début de la remise",
      no_time_selected: "Aucune heure de début sélectionnée",
    },
    end_time: {
      title: "Date de fin de la remise",
      no_time_selected: "Aucune heure de fin sélectionnée",
    },
  },
  counterService: {
    typeLabel: "Type d'affichage",
    number: "Nombre",
    percent: "Pourcent",
    iconLabel: "Icône",
    counterLabel: "Valeur",
    linkLabel: "Lien",
    nameLabel: "Titre",
    addButton: "Ajouter un succès",
    successful: {
      added: "Élément ajouté avec succès",
      removed: "Élément supprimé avec succès",
      movedUp: "Élément déplacé vers le haut avec succès",
      movedDown: "Élément déplacé vers le bas avec succès",
    },
  },
  qrUsersList: {
    customersList: "Liste des clients",
    orders: "Commandes",
    addresses: "Adresses",
    hasAssistantsMobile_hint: "Sélectionner le mobile",
    invalidPhone: "Le numéro de mobile saisi n'est pas valide",
    validation: {
      nameRequired: "Le prénom est obligatoire",
      nameMinLength: "Le prénom doit contenir au moins 2 caractères",
      familyRequired: "Le nom de famille est obligatoire",
      familyMinLength: "Le nom de famille doit contenir au moins 2 caractères",
    },
    addUser: "Ajouter un utilisateur",
    registerOnline: "Activer l'inscription en ligne",
    usersColumns: {
      id: "ID",
      name: "Prénom",
      family: "Nom de famille",
      mobile: "Mobile",
      subscriptionId: "ID d'abonnement",
      ordersCount: "Nombre de commandes",
      lastLogin: "Dernière connexion",
      status: "Statut",
      activeUser: "Utilisateur actif",
      none: "-",
      actions: "Actions",
      buttons: {
        info: "Données client",
        sendSms: "Envoyer un SMS",
        history: "Historique",
        addresses: "Adresses",
        orders: "Commandes",
      },
    },
    orderColumns: {
      orderId: "Numéro de commande",
      customerName: "Nom du client",
      mobile: "Mobile",
      paymentMethod: "Méthode de paiement",
      shippingMethod: "Méthode d'expédition",
      orderAmount: "Montant de la commande",
      orderTime: "Heure de la commande",
      status: "Statut",
      currency: "Rial",
    },
    addressesColumns: {
      id: "#",
      addressTitle: "Titre de l'adresse",
      name: "Prénom",
      family: "Nom de famille",
      mobile: "Téléphone",
      address: "Adresse",
      zipCode: "Code postal",
      number: "Numéro de maison",
      unit: "Unité",
    },
    shippingType: {
      courier: "Courrier",
      reservation: "Réservation de table",
      place: "Ramassage sur place",
      none: "-",
    },
    paymentType: {
      online: "Paiement en ligne",
    },
    perPage: "Entrées par page",
    search: "Rechercher",
    sortColumn: "Trier par",
    sortDirection: "Direction de tri",
    sortDirectionDesc: "Décroissant",
    sortDirectionAsc: "Croissant",
    noStatus: "Aucun statut trouvé",
    status: {
      all: "Tous",
      active: "Actif",
      inactive: "Inactif",
    },
    fetchError: "Erreur lors du chargement des données utilisateur",
  },
  listCardHeader: {
    clear_filters: "Effacer les filtres",
    group_qr_renewal: "Renouvellement groupé de code QR",
    select_desired_duration: "Sélectionner la durée souhaitée",
    total_count: "Nombre total",
    final_amount: "Montant final",
    ten_percent_vat_will_be_added: "10 % de TVA seront ajoutés",
    pay_and_upgrade: "Payer & mettre à niveau",
    no_tariff_for_this_period: "Aucun tarif pour cette période",
    one_month_renewal: "Renouvellement de 1 mois",
    three_month_renewal: "Renouvellement de 3 mois",
    six_month_renewal: "Renouvellement de 6 mois",
    one_year_renewal: "Renouvellement de 1 an",
    selected: "Sélectionné",
    view: "Voir",
    details: "Détails",
    total_amount: "Montant total",
    discount: "Remise",
    final_amount_with_discount: "Montant final avec remise",
    add_qr: "Ajouter un QR",
    select_all: "Tout sélectionner",
    actions: "Actions",
    filter: "Filtrer",
    type_filter: "Filtre de type",
    start_from: "Commence par",
    search: "Rechercher",
    id_search: "Recherche d'ID",
    filter_user: "Filtre utilisateur",
    sort: "Trier",
    send_sms: "Envoyer un SMS",
    selected_pattern: "Modèle sélectionné :",
    send: "Envoyer",
    newest: "Plus récent",
    oldest: "Plus ancien",
    most_visited: "Le plus visité",
    least_visited: "Le moins visité",
    pause: "Pause",
    bulk_download: "Téléchargement groupé",
    activate: "Activer",
    deactivate: "Désactiver",
    error_loading_card: "Erreur lors du chargement des données de carte !",
    error_fetching_prices: "Erreur lors de la récupération des prix !",
    error_payment: "Erreur de paiement !",
    sms_success: "SMS envoyé avec succès",
    generic_error: "Une erreur s'est produite !",
  },
  headerTypeFilter: {
    qr_model: "Modèle QR",
    all_qr_models: "Tous les modèles QR",
  },
  menuOrderFactor: {
    order_invoice: "Facture de commande",
    total: "Total",
    tax: "Taxe",
    shipping_cost: "Frais d'expédition",
    packing_cost: "Frais d'emballage",
    discount: "Remise",
    final_total: "Total final",
    currency: "Rial",
    titles: {
      default_title: "Commande standard",
    },
  },
  headerSearchTypeFilter: {
    search_in_list: "Rechercher dans la liste",
    search: "Rechercher",
    start_from: "Commence par",
  },
  headerStatusFilter: {
    all_qr_codes: "Tous les codes QR",
    active_qr_codes: "Codes QR actifs",
    inactive_qr_codes: "Codes QR inactifs",
    expiring_qr_codes: "Codes QR expirant bientôt",
    expired_qr_codes: "Codes QR expirés",
  },
  qrOrdersList: {
    title: "Liste des commandes",
    orderColumns: {
      index: "Ordre",
      id: "Numéro de commande",
      customerName: "Nom du client",
      mobile: "Mobile",
      paymentType: "Type de paiement",
      shippingType: "Type d'expédition",
      price: "Montant de la commande",
      createdAt: "Heure de la commande",
      status: "Statut",
      actions: "Actions",
    },
    productsColumns: {
      productId: "ID produit",
      image: "Image",
      productName: "Nom du produit",
      unitPrice: "Prix unitaire",
      quantity: "Quantité",
      totalPrice: "Prix total",
    },
    actions: {
      products: "Liste de commande",
      print: "Imprimer la commande",
      share: "Partager la commande",
      status: "Changer le statut",
    },
    shippingType: {
      courier: "Courrier",
      reservation: "Réservation de table",
      place: "Ramassage sur place",
      post: "Livraison postale",
      unknown: "-",
    },
    paymentType: {
      online: "Paiement en ligne",
      place: "Paiement sur place",
      card2card:"Paiement carte à carte",
      unknown: "-",
    },
    status: {
      all: "Tous",
      pending: "Paiement en attente",
      accepted: {
        place: "Paiement sur place",
        paid: "Payé",
      },
      delivered: "Livré",
      rejected: "Paiement échoué",
    },
    factorTitle: "Facture de commande",
    printFactor: "Imprimer la facture",
    fetchError: "Erreur lors du chargement des données",
    statusChanged: "Statut changé avec succès",
    statusChangeError: "Erreur lors du changement de statut",
    currency: "Rial",
    perPage: "Compte",
    search: "Rechercher",
    noStatus: "Aucun statut",
    loading: "Chargement...",
    noShippingType: "Aucun type d'expédition",
    noPaymentType: "Aucun type de paiement",
    sortColumn: "Colonne de tri",
    sortDirection: "Direction de tri",
    sortDirectionDesc: "Décroissant",
    sortDirectionAsc: "Croissant",
    selectNewStatus: "Sélectionner un nouveau statut",
    changeStatusTitle: "Changer le statut",
    linkCopied: "Lien copié.",
  },
  qrUserTransfer: {
    title: "Transfert de propriété",
    radioLabels: {
      userTransfer: "Transférer à une autre personne",
      givingAccess: "Accorder l'accès",
    },
    inputLabels: {
      phone: "Numéro de mobile de la personne",
    },
    hints: {
      addNumber: "Appuyez sur Entrée ou + pour ajouter",
      addNumberStep2: "Appuyez sur Entrée ou + pour ajouter",
    },
    buttons: {
      transfer: "Transférer",
      giveAccess: "Accorder l'accès",
      back: "Retour",
      saveChanges: "Enregistrer les modifications",
      cancel: "Annuler",
        "add": "Ajouter"

    },
    tooltips: {
      deleteAccess: "Supprimer l'accès",
    },
    subtitles: {
      accessList: "Liste des utilisateurs autorisés :",
      selectPermissions: "Sélectionner les permissions :",
    },
    permissionList: {
      edit_name: "Modifier le nom du service",
      edit_link: "Modifier le lien",
      edit_info: "Modifier les informations",
      edit_design: "Modifier le design du QR",
      edit_settings: "Modifier les paramètres du QR",
      toggle_access: "Activer/désactiver l'accès",
      view_customers: "Voir la liste des clients",
      view_orders: "Voir la liste des commandes",
    },
    messages: {
      invalidPhone: "Numéro de téléphone invalide",
      duplicatePhone: "Numéro en double non autorisé",
      updateAccessSuccess: "Accès mis à jour avec succès.",
      updateAccessError: "Erreur de mise à jour : {message}",
      deleteAccessSuccess: "Accès supprimé avec succès.",
      deleteAccessError: "Erreur de suppression : {message}",
      fetchAccessError: "Erreur de chargement : {message}",
      transferSuccess: "QR transféré avec succès.",
      transferError: "Erreur de transfert : {message}",
      giveAccessSuccess: "Configuration réussie.",
      giveAccessError: "Erreur de configuration : {message}",
      confirmDeleteAccess:
        "Voulez-vous vraiment supprimer l'accès de cette personne ?",
    },
  },
  form: {
    form_download: "Formulaires reçus",
    form_add: "Ajouter un formulaire",
    formdownload: "Formulaire reçu",
    create_at: "Créé le :",
    shown: "Affiché",
    nogiveform: "Vous n'avez aucun formulaire reçu",
    back: "Retour",
    invalid_date: "Date invalide",
    select_date: "Sélectionner une date",
    select: "Sélectionner",
    clear: "Effacer",
    now: "Maintenant",
  },
  dsBasketCondition: {
    title: "Conditions minimales du panier",
    items: {
      NoConditions: "Aucune condition",
      MinimumShopping: "Montant minimum du panier",
      MinimumProduct: "Produits minimum dans le panier",
      MaximumShopping: "Montant maximum du panier",
      MaximumProduct: "Produits maximum dans le panier",
    },
  },
  dsUserSettings: {
    title: "Conditions minimales du panier",
    groupTitle: "Utilisateurs qui",
    specialTitle: "Utilisateurs",
    labels: {
      minimumCart: "Conditions minimales du panier",
      users: "Utilisateurs",
    },
    items: {
      AllUser: "Tous les utilisateurs",
      group: "Groupe d'utilisateurs",
      special: "Utilisateurs spéciaux",
    },
    groupItems: {
      Order: "Ont déjà acheté",
      noOrder: "N'ont pas encore acheté",
    },
  },
  qrAddressUpdate: {
  title: "Modifier l’adresse",
  labels: {
    address: "Adresse QR",
  },
  hints: {
    allowedChars: "Seules les lettres anglaises, les chiffres, les tirets (-) et les underscores (_) sont autorisés",
  },
  buttons: {
    removeInvalidChars: "Supprimer les caractères non valides",
  },
  errors: {
    minLength: "Au moins 3 caractères sont requis",
    invalidChars: "Caractère non valide ! Utilisez uniquement des lettres anglaises, des chiffres, - et _.",
    invalidAddress: "L’adresse saisie est invalide",
    updateFailed: "Échec de la mise à jour de l’adresse",
  },
  successMessage: "Adresse mise à jour avec succès",
  warning: "Avertissement",
  warningMessage: "La modification de l’adresse entraînera la désactivation des anciens liens.",
  savePrompt: "Êtes-vous sûr de vouloir enregistrer cette modification ?",
},
  dsFunctionType: {
    title: "La remise s'applique à",
    productListTitle: "Liste de produits",
    categoryListTitle: "Liste de catégories",
    labels: {
      applyDiscount: "Appliquer la remise à",
      category: "Catégorie",
    },
    items: {
      AllShoppingCart: "Montant total du panier",
      SpecialProducts: "Produits spéciaux",
      SpecialCategories: "Catégories spéciales",
    },
  },
  dsLimitationUse: {
    title: "Limitation d'utilisation",
    discountCodeTitle: "Utilisations du code",
    userTitle: "Utilisations par utilisateur",
    labels: {
      limitation: "Limitation",
      usage: "Utilisation",
      user: "Utilisateur",
    },
    items: {
      NoLimitations: "Aucune limitation",
      DiscountCode: "Utilisations du code de réduction",
      User: "Utilisations par utilisateur",
    },
  },
  ManageHourLimitQr: {
    noLimit: "Aucune limite",
    dateLimit: "Limite de date",
    timeLimit: "Limite d'heure",
    startDate: "Date de début",
    endDate: "Date de fin",
    selectDate: "Sélectionner une date",
    startTime: "Heure de début",
    endTime: "Heure de fin",
  },
  discount_percent_range: "La remise doit être entre 0 et 100 %",
  discount_price_range: "La remise doit être entre 0 et {max}",
  invalid_number: "Entrez uniquement des nombres",
  min_order_cart: "Valeur minimale de commande",
  preparation_time: "Temps de préparation (minutes)",
  delivery_time: "Temps de livraison (minutes)",
  max_product_in_order: "Max. de produits par commande",
  max_order_by_person: "Max. de commandes par personne",
  send_by_courier_price: "Frais de courrier",
  vat: "Taux de taxe",
  send_by_post: "Frais de livraison postale",
  online_pay: "Paiement en ligne",
  pay_in_person_place: "Paiement sur place",
  in_place: "Ramassage sur place",
  table_booking_ability: "Réservation de table",
  send_by_courier: "Livraison par courrier",
  vat_switch: "Taxe",
  invalid_number: "Entrez uniquement des nombres",
  positive_number: "Le nombre doit être positif",
  vat_range: "Le taux de taxe doit être entre 0 et 100 %",
  sort_column: "Colonne de tri",
  direction_sort: "Direction de tri",
  listFeedbackUser: {
    no_questions: "Vous n'avez aucune question pour la collecte de retours",
    add_feedback_prompt: "Créez un nouveau retour dans l'onglet 'Ajouter'",
    question_label: "Question",
    show_answers: "Afficher les réponses",
    back_button: "Retour",
    no_feedback: "Aucun retour disponible !",
    user_opinion: "Opinion de l'utilisateur",
    score_label: "Note",
  },
  manageDiscount: {
    createNewDiscount: "Créer un nouveau code de réduction",
    copy: "Copier",
    row: "Ligne",
    id: "ID",
    discountCode: "Code de réduction",
    usageLimit: "Limite d'utilisation",
    used: "Utilisé",
    manage: "Gérer",
    edit: "Modifier",
    delete: "Supprimer",
    sendSms: "Envoyer un SMS au groupe cible",
    copySuccess: "Code de réduction copié",
    copyError: "Erreur de copie",
    deleteSuccess: "Code de réduction supprimé",
    deleteError: "Erreur lors de la suppression du code de réduction",
    smsSuccess: "Code de réduction envoyé au groupe cible",
    smsError: "Erreur d'envoi",
  },
  manageTableReservation: {
    table: "Table",
    number: "Table {num}",
    add_table: "Ajouter une table",
    complete_info_for_customer: "Remplissez les infos à afficher au client",
    select_image: "Sélectionner une image",
    table_name_number: "Nom/numéro de table",
    number_of_seats: "Nombre de places",
    type: "Type",
    reservation_cost: "Coût de réservation",
    enter_table_name: "Entrez le nom/numéro de table",
    table_type: "Table",
    couch_type: "Canapé",
    gazebo_type: "Kiosque",
  },
  create_menu: {
    data: {
      visitName_label: "Nom de visite",
      organizationName: "Grande chaîne de fast-food",
      subOrgan: "Essayez le meilleur goût de fast-food avec nous",
      aboutUs:
        "Grand Fast-Food – avec qualité et respect pour le client, nous offrons le meilleur.\nLa qualité est notre principe.\nDans le secteur du fast-food, nous avons introduit un nouveau goût au monde des repas rapides avec nos sandwiches spéciaux\nNous sommes prêts chaque jour à vous servir lors d'événements administratifs, d'anniversaires et plus...",
      copyright:
        "Tous les droits de ce site appartiennent à Terminal Advertising.",
      product: {
        title: "Produits",
        pizzas: "Pizzas",
        pizza_roast_beef: "Pizza Roast Beef",
        pizza_roast_beef_desc: "🤩 Pizza italienne au bœuf",
        pizza_roast_beef_ingredients:
          "Base de pizza italienne 30 cm, 100 g de bœuf haché, champignons, poivrons, olives noires",
        pizza_chicken_mushroom: "Pizza Poulet & Champignons",
        pizza_chicken_mushroom_desc: "🍕 Classique 40 cm",
        pizza_chicken_mushroom_ingredients:
          "Sauce tomate Pizzara fraîche, fromage pasteurisé, filet de poulet, champignons, thym de montagne",
        pizza_meat_mushroom: "Pizza Viande & Champignons",
        pizza_meat_mushroom_desc: "🥰 Pizza au bœuf haché et champignons",
        pizza_meat_mushroom_ingredients:
          "Sauce tomate Pizzara fraîche, fromage pasteurisé, bœuf haché de haut de surlonge, champignons, thym de montagne, pour 2 personnes (29 cm) 355.000 Toman, pour 1 personne (22 cm) 216.000 Toman",
        pizza_veggie: "Pizza Végétarienne",
        pizza_veggie_desc: "🍕 Pizza végétarienne américaine",
        pizza_veggie_ingredients:
          "Base de pizza américaine, maïs doux, champignons, olives, tomates, oignons, poivrons, fromage à pizza",
        pizza_special: "Pizza Spéciale",
        pizza_special_desc: "Pizza spéciale américaine",
        pizza_special_ingredients:
          "Base de pizza américaine, bœuf haché assaisonné, mélange hamburger bœuf & poulet 80 %, mélange mozzarella, sauce spéciale, poivrons, champignons, sans sauce pour 1 personne",
        pizza_bolognese: "Pizza Bolognese",
        pizza_bolognese_desc: "(Pour 1 personne) Base de pizza 23 cm 🤌",
        pizza_bolognese_ingredients:
          "Bœuf haché, mozzarella, champignons, poivrons, maïs doux, olives noires en tranches",
        pizza_pepperoni: "Pizza Pepperoni",
        pizza_pepperoni_desc: "(Pour 1 personne) Base de pizza 23 cm",
        pizza_pepperoni_ingredients:
          "Base de pizza italienne, pepperoni 80 %, sauce marinara, fromage à pizza spécial",
        pizza_bacon: "Pizza Bacon",
        pizza_bacon_desc: "(Pour 1 personne) Base de pizza 23 cm 💥",
        pizza_bacon_ingredients:
          "Base de pizza italienne, sauce marinara, fromage à pizza spécial, mélange bacon bœuf & poulet 90 %, champignons, olives, poivrons",
        pizza_mixed: "Pizza Mixte",
        pizza_mixed_desc: "(Pour 1 personne) Base de pizza 23 cm 🤭",
        pizza_mixed_ingredients:
          "Mélange hamburger bœuf & poulet haché, salami, bœuf haché, champignons, olives, poivrons, fromage à pizza, sauce spéciale",
        pizza_american_steak: "Pizza Steak Américaine",
        pizza_american_steak_desc: "(Pour 1 personne) 23 cm 💥",
        pizza_american_steak_ingredients:
          "Base de pizza américaine, morceaux de bœuf, champignons, fromage à pizza, sésame",
        burgers: "Burgers",
        cheeseburger: "Cheeseburger",
        cheeseburger_desc: "🤩 Avec frites",
        cheeseburger_ingredients:
          "2 steaks de burger de bœuf de 150 g chacun, sauce spéciale, fromage Gouda, cornichon, laitue, tomate",
        hamburger: "Hamburger",
        hamburger_desc: "😍 Bœuf pur avec sauce spéciale",
        hamburger_ingredients:
          "Steak de burger de bœuf 150 g, cornichon, laitue, sauce spéciale, tomate, pain Mac, sauce pour 1 personne",
        chicken_burger: "Burger Poulet",
        chicken_burger_desc: "Poulet grillé avec fromage",
        chicken_burger_ingredients:
          "150 g de poitrine de poulet grillée, fromage, tomate, cornichon, laitue, pain Mac, sauce spéciale",
        spice_burger: "Burger Épicé",
        spice_burger_desc: "Bœuf avec sauce épicée",
        spice_burger_ingredients:
          "Steak de burger de bœuf 130 g, sauce épicée, laitue, tomate, pain Mac, sauce épicée spéciale",
        double_burger: "Double Burger",
        double_burger_desc: "Bœuf 150 g",
        double_burger_ingredients:
          "2 steaks de bœuf faits main de 150 g chacun, fromage à pizza, sauce caramel, laitue, chou rouge, sauce blanche spéciale, pain rond",
        royal_burger: "Burger Royal",
        royal_burger_desc: "150 g de bœuf 🍔",
        royal_burger_ingredients:
          "Steak de bœuf fait main 150 g, fromage à pizza, 5 tranches de salami, sauce caramel, laitue, chou rouge, sauce blanche spéciale, pain rond",
        mushroom_burger: "Burger Champignons",
        mushroom_burger_desc: "Bœuf 150 g",
        mushroom_burger_ingredients:
          "Steak de bœuf fait main 150 g, champignons, sauce caramel, laitue, chou rouge, sauce blanche spéciale, pain rond, mozzarella",
        mashroom_burger: "Burger Champignons",
        mashroom_burger_desc: "100 % bœuf grillé 🤩",
        mashroom_burger_ingredients:
          "Steak de bœuf 100 % grillé fait main, frites, tomate, laitue, cornichon, sauce aux champignons, pain rond",
        fried_burger: "Burger Frit",
        fried_burger_desc: "100 % bœuf grillé & frit 👌",
        fried_burger_ingredients:
          "Steak de bœuf 100 % grillé & frit fait main, 150 g de frites, tomate, laitue, cornichon, sauce spéciale, pain rond",
        fried: "Frit",
        fried_chicken: "Poulet Frit",
        fried_chicken_desc: "😍 3 morceaux de poulet frit",
        fried_chicken_ingredients:
          "3 morceaux de poulet frit, 120–150 g de frites, 100–120 g de salade de chou, petit pain, sauce spéciale",
        chicken_strips: "Lanières de Poulet",
        chicken_strips_desc:
          "4 morceaux de filet de poulet frit épicé assaisonné",
        chicken_strips_ingredients:
          "4 morceaux de filet de poulet frit, 120–150 g de frites, 100–120 g de salade de chou, petit pain, sauce tartare",
        fried_filet: "Filet Frit",
        fried_filet_desc: "🤩 2 morceaux de filet frit avec sauce spéciale",
        fried_filet_ingredients:
          "2 morceaux de lanières, pommes de terre grillées, salade de chou, petit pain, sauce à l'ail, sauce chili thaï, sauce paprika",
        fried_mushroom_onion: "Champignons & Oignons Frits",
        fried_mushroom_onion_desc:
          "🤩 Champignons & oignons frits avec sauce tartare",
        fried_mushroom_onion_ingredients:
          "20 morceaux de champignons frits, 6 morceaux d'oignons frits, sauce tartare",
        fried_wings: "Ailes Frites",
        fried_wings_desc: "6 morceaux d'ailes frites 🍗",
        fried_wings_ingredients: "Six ailes grillées & frites",
        fried_chicken_basket: "Panier de Poulet Frit",
        fried_chicken_basket_desc: "(Pour 2 personnes) 😍",
        fried_chicken_basket_ingredients:
          "2 morceaux de poulet frit, 2 morceaux de lanières, 2 morceaux d'oignons frits, 2 morceaux de nuggets de crevettes frites, 2 morceaux de nuggets de poulet",
        fried_schnitzel: "Schnitzel Frit",
        fried_schnitzel_desc: "Quatre morceaux de schnitzel de poulet 💥",
        fried_schnitzel_ingredients:
          "Quatre schnitzels de poulet assaisonnés grillés & frits",
        veggie_basket_fried: "Panier Végétarien Frit",
        veggie_basket_fried_desc: "250 g 🤩",
        veggie_basket_fried_ingredients:
          "250 g, courgettes frites, aubergines, champignons, pommes de terre",
        fried_chicken_2_piece: "Poulet Frit 2 Morceaux",
        fried_chicken_2_piece_desc: "2 morceaux de poulet frit 🍗",
        fried_chicken_2_piece_ingredients:
          "120–150 g de frites, 100–120 g de salade de chou, petit pain, sauce spéciale",
        fried_chicken_5_piece: "Poulet Frit 5 Morceaux",
        fried_chicken_5_piece_desc: "Cinq morceaux de poulet frit",
        fried_chicken_5_piece_ingredients:
          "150–200 g de frites, deux salades de chou 100–120 g, deux petits pains, sauce spéciale",
        fried_chicken_7_piece: "Poulet Frit 7 Morceaux",
        fried_chicken_7_piece_desc: "Sept morceaux de poulet frit 💥",
        fried_chicken_7_piece_ingredients:
          "150–200 g de frites, salade de chou 100–120 g, 3 petits pains, sauce spéciale, sauce pour 1 personne frit",
        sandwich: "Sandwich",
        hotdog_sandwich: "Sandwich Hotdog",
        hotdog_sandwich_desc: "Sandwich hotdog avec champignons et fromage",
        hotdog_sandwich_ingredients:
          "Saucisse hotdog grillée, laitue, tomate, cornichon, champignons et fromage à pizza",
        roast_beef_sandwich: "Sandwich Roast Beef",
        roast_beef_sandwich_desc: "✔️ Bœuf haché",
        roast_beef_sandwich_ingredients:
          "Bœuf, fromage à pizza, champignons, chips de pommes de terre en tranches, laitue, tomate, cornichon, sauce spéciale, pain français",
        ham_sandwich: "Sandwich Jambon",
        ham_sandwich_desc: "Sandwich jambon de poulet avec champignons (froid)",
        ham_sandwich_ingredients:
          "Jambon de poulet avec champignons, laitue, tomate, cornichon, chips de pommes de terre en tranches, sauce spéciale, baguette",
        bandari_sausage_sandwich: "Sandwich Saucisse Bandari",
        bandari_sausage_sandwich_desc: "💥 Sandwich Bandari épicé",
        bandari_sausage_sandwich_ingredients:
          "Nourriture Bandari avec saucisse cocktail fumée 55 %, tomate, cornichon, sauce spéciale, oignon et coriandre, pain volumineux",
        tongue_mushroom_sandwich: "Sandwich Langue & Champignons",
        tongue_mushroom_sandwich_desc: "150 g de langue de bœuf",
        tongue_mushroom_sandwich_ingredients:
          "Champignons, fromage à pizza pasteurisé, olives, maïs doux, laitue, cornichon, tomate, sauce, accompagnements, frites, salade de chou",
        falafel_sandwich: "Sandwich Falafel",
        falafel_sandwich_desc: "Six morceaux de falafel 🌭",
        falafel_sandwich_ingredients:
          "Six morceaux de falafel, cornichon, tomate, laitue, sauce pour 1 personne, accompagnements, frites, salade de chou",
        cheesy_kebab_turki_sandwich: "Sandwich Kebab Turc Fromagé",
        cheesy_kebab_turki_sandwich_desc: "150 g de bœuf",
        cheesy_kebab_turki_sandwich_ingredients:
          "150 g de bœuf, fromage à pizza spécial, cornichon, tomate, laitue, sauce pour 1 personne, frites, salade de chou",
        roast_chicken_sandwich: "Sandwich Poulet Grillé",
        roast_chicken_sandwich_desc: "Schnitzel de poulet et champignons 🤩",
        roast_chicken_sandwich_ingredients:
          "Schnitzel de poulet et champignons, fromage à pizza spécial, olives, maïs doux, sésame, laitue, poivrons, cornichon, tomate, sauce spéciale, accompagnements, frites",
        cheesy_indian_sandwich: "Sandwich Indien Fromagé",
        cheesy_indian_sandwich_desc: "Saucisse allemande 💥",
        cheesy_indian_sandwich_ingredients:
          "Saucisse au fromage allemande, maïs doux, laitue, champignons, sauce spéciale, accompagnements, frites, salade de chou",
        snack: "Snack",
        chicken_snack: "Snack Poulet",
        chicken_snack_desc: "😋 Poitrine de poulet hachée",
        chicken_snack_ingredients:
          "150 g de poitrine de poulet, poivrons, champignons, pain snack spécial, sauce spéciale",
        meat_snack: "Snack Viande",
        meat_snack_desc: "🥪 Snack double viande",
        meat_snack_ingredients:
          "Double, bœuf haché de haut de surlonge, mozzarella, maïs doux, poivrons, sauce spéciale, pain toast",
        chicken_meat_snack: "Snack Poulet-Viande",
        chicken_meat_snack_desc: "🤩 Snack double poulet-viande",
        chicken_meat_snack_ingredients:
          "Double, poitrine de poulet hachée, bœuf haché de haut de surlonge, mozzarella, maïs doux, poivrons, sauce spéciale, pain toast",
        special_snack: "Snack Spécial",
        special_snack_desc: "🤤 Snack double spécial",
        special_snack_ingredients:
          "Double, mélange kalbas bœuf & poulet 90 %, mozzarella, maïs doux, poivrons, sauce spéciale, pain toast",
        roast_beef_snack: "Snack Roast Beef",
        roast_beef_snack_desc: "Bœuf haché 🍖",
        roast_beef_snack_ingredients:
          "Bœuf haché, champignons, fromage à pizza, poivrons, maïs doux, accompagnements, frites, salade de chou",
        veggie_snack: "Snack Végétarien",
        veggie_snack_desc: "4 morceaux de snack végétarien",
        veggie_snack_ingredients:
          "Brocoli, maïs doux, olives, fromage à pizza diététique, champignons, accompagnements, frites, salade de chou",
        chicken_mushroom_snack: "Snack Poulet & Champignons",
        chicken_mushroom_snack_desc: "Schnitzel de poulet et champignons 👌",
        chicken_mushroom_snack_ingredients:
          "Schnitzel de poulet, champignons, fromage à pizza spécial, olives, maïs doux, poivrons, accompagnements, frites, salade de chou",
        pepperoni_snack: "Snack Pepperoni",
        pepperoni_snack_desc: "Kalbas pepperoni 90 % 💥",
        pepperoni_snack_ingredients:
          "Double, kalbas pepperoni 90 %, mozzarella, maïs doux, poivrons, sauce spéciale",
        bologna_snack: "Snack Bologna",
        bologna_snack_desc: "Bœuf haché 👌",
        bologna_snack_ingredients:
          "Double, bœuf haché, bacon spécial, champignons blanchis, maïs doux, mozzarella, poivrons, sauce spéciale",
        pasta: "Pâtes",
        alfredo_pasta: "Pâtes Alfredo",
        alfredo_pasta_desc: "Pâtes Alfredo avec sauce spéciale aux champignons",
        alfredo_pasta_ingredients: "350 g de penne",
        macaroni: "Macaroni",
        macaroni_desc: "🥣 Macaroni avec viande et champignons",
        macaroni_ingredients:
          "Pâtes ruban 1,2, 100 g de bœuf haché, champignons, poivrons, pommes de terre grillées en dés, pois",
        spaghetti_bolognese: "Spaghetti Bolognese",
        spaghetti_bolognese_desc: "🥰 Pâtes linguine",
        spaghetti_ingredients:
          "700 g, pâtes linguine, bœuf et agneau hachés, sauce bolognese, sauce rouge Rasu spéciale, cuillère et fourchette en plastique en option",
        chicken_stroganoff: "Stroganoff au Poulet",
        chicken_stroganoff_desc:
          "😍 Stroganoff au poulet avec morceaux de poitrine de poulet",
        chicken_stroganoff_ingredients:
          "180 g de morceaux de poitrine de poulet assaisonnés, crème, champignons blanchis, parmesan, frites coupées à la main, contenant spécial pour micro-ondes",
        penne_arrabbiata: "Penne Arrabbiata",
        penne_arrabbiata_desc: "Poitrine de poulet 💥",
        penne_arrabbiata_ingredients:
          "Pour 1 personne, poitrine de poulet, pâtes, champignons, parmesan, tomates cerises, persil, sauce arrabbiata",
        chicken_pesto_pasta: "Pâtes Pesto au Poulet",
        chicken_pesto_pasta_desc: "(Pour 1 personne) Poitrine de poulet",
        chicken_pesto_pasta_ingredients:
          "Poitrine de poulet, champignons, parmesan, tomates cerises, persil, sauce arrabbiata",
        carbonara_pasta: "Pâtes Carbonara",
        carbonara_pasta_desc: "Bacon de bœuf 97 %",
        carbonara_pasta_ingredients:
          "Pâtes, bacon de bœuf 97 %, sauce alfredo, parmesan, tomates cerises, persil",
        appetizer: "Entrées",
        hot_chips: "Chips Chaudes",
        hot_chips_desc: "😙 Diverses saveurs de chips",
        hot_chips_ingredients:
          "Chips au kilo, sauce spéciale, jambon de poulet 70 %, champignons, poivrons, fromage à pizza, Gouda",
        lasagna: "Lasagne",
        lasagna_desc: "Lasagne au bœuf haché",
        lasagna_ingredients:
          "3 feuilles de lasagne, bœuf haché, champignons, poivrons, olives noires, fromage à pizza, sauce spéciale",
        french_fries: "Frites",
        french_fries_desc: "Frites avec sauce spéciale",
        french_fries_ingredients: "150 g de frites, sauce spéciale",
        baked_potato: "Pomme de terre au four",
        baked_potato_desc: "🍟 Pomme de terre au four avec bacon de bœuf",
        baked_potato_ingredients:
          "150 g de frites, bacon de bœuf 90 %, fromage à pizza, assaisonnement spécial, sauce individuelle",
        garlic_bread: "Pain à l'ail",
        garlic_bread_desc: "Sauce à l'ail spéciale💥",
        garlic_bread_ingredients:
          "Pâte à pizza américaine, mélange de fromage à pizza, sauce à l'ail spéciale, graines de sésame",
        silo_potatoes: "Pommes de terre Silo",
        silo_potatoes_desc: "Frites pour deux personnes",
        silo_potatoes_ingredients:
          "Frites assaisonnées Silo, bacon de bœuf 97 %, sauce cheddar, aïoli, ciboule, persil",
        bbq_sausage: "Saucisse barbecue",
        bbq_sausage_desc: "Saucisse doigt marinée🍢",
        bbq_sausage_ingredients:
          "500 g de purée de pommes de terre assaisonnée, 200 g de saucisse doigt marinée, rondelles d'oignon, olives vertes, poudre de parmesan, tomates cerises, micro-pousses, fromage grillable, sauce barbecue, épicé",
        silo_toast: "Toast Silo",
        silo_toast_desc: "160 g de tranches de rumsteck de bœuf🤩",
        silo_toast_ingredients:
          "160 g de tranches de rumsteck de bœuf, laitue française, bacon de bœuf, pain fermier, sauce barbecue, sauce tartare, oseille, olives vertes, micro-pousses, aïoli, poudre de parmesan",
        salad_and_dessert: "Salade et dessert",
        caesar_salad: "Salade César",
        caesar_salad_desc: "Salade César individuelle🥗",
        caesar_salad_ingredients:
          "Mélange de laitues, poulet grillé, parmesan, croûtons (pain à l'ail), sauce César, olives",
        caesar_salad_extra: "Laitue romaine, croûtons, parmesan",
        coleslaw_salad: "Salade de chou",
        coleslaw_salad_desc: "Salade de chou individuelle🍴",
        coleslaw_salad_ingredients:
          "Fait maison, individuelle, chou blanc, maïs, sauce",
        macaroni_salad: "Salade de macaronis",
        macaroni_salad_desc: "Salade de macaronis avec jambon maison",
        macaroni_salad_ingredients: "Macaronis, jambon maison",
        pachira_salad: "Salade Pachira",
        pachira_salad_desc: "Salade Pachira pour deux🥗",
        pachira_salad_ingredients:
          "Pour deux, mélange de laitues, chips de bacon de bœuf 98 %, noix caramélisées, parmesan, fraises, caviar végétal, raisins secs, tranches de citron, sauce aux baies roses",
        greek_salad: "Salade grecque",
        greek_salad_desc: "Salade grecque traditionnelle avec feta et olives",
        greek_salad_ingredients: "Feta, olives, concombre",
        tiramisu: "Tiramisu",
        tiramisu_desc: "Tiramisu classique italien",
        tiramisu_ingredients: "Café, mascarpone, cacao",
        beverages: "Boissons",
        local_yogurt_drink: "Boisson au yaourt local",
        local_yogurt_drink_desc: "Boisson au yaourt local familiale🥛",
        local_yogurt_drink_ingredients: "",
        black_soda: "Soda noir",
        black_soda_desc: "Verre de soda noir🧋",
        black_soda_ingredients: "",
        fanta: "Soda jaune",
        fanta_desc: "Verre de soda jaune🥤",
        fanta_ingredients: "",
        mojito: "Mojito",
        mojito_desc: "Verre de mojito, 350 à 400 ml🍸",
        mojito_ingredients: "",
        tropical_malt_beverage: "Boisson maltée tropicale",
        tropical_malt_beverage_desc: "Verre de boisson maltée tropicale🍺",
        tropical_malt_beverage_ingredients: "",
      },
      socialMedia: {
        address_label: "Adresse",
        address_text: "Entrez le lien vers le site web souhaité",
        instagram_label: "Instagram",
        instagram_text: "Entrez votre nom d'utilisateur",
        whatsapp_label: "WhatsApp",
        whatsapp_text: "+989123456789",
      },
      videoGallery: {
        title: "Galerie vidéo",
        description:
          "Pour en savoir plus sur les services du système intelligent QR-Land, veuillez regarder les vidéos ci-dessous.",
        tutorial: "Didacticiel",
        fast_food: "Fast-food",
      },
      feedback: {
        title: "Votre avis",
        description:
          "Veuillez répondre aux questions ci-dessous pour nous aider à améliorer nos services",
        question1:
          "Dans quelle mesure êtes-vous satisfait de nos services et de la qualité de la nourriture ?",
        question2: "Comment évaluez-vous la variété des plats du restaurant ?",
        question3:
          "Comment évaluez-vous le comportement du personnel du restaurant ?",
        question4: "La nourriture a-t-elle été livrée à temps ?",
        question5:
          "Avez-vous des suggestions pour améliorer nos services ou la qualité de la nourriture ?",
      },
      worksheet: {
        saturday: "Samedi",
        sunday: "Dimanche",
        monday: "Lundi",
        tuesday: "Mardi",
        wednesday: "Mercredi",
        thursday: "Jeudi",
        friday: "Vendredi",
        shift_1_saturday: "10:00 à 22:00",
        shift_1_sunday: "10:00 à 22:00",
        shift_1_monday: "10:00 à 22:00",
        shift_1_tuesday: "10:00 à 22:00",
        shift_1_wednesday: "10:00 à 00:00",
        shift_1_thursday: "10:00 à 00:00",
        shift_1_friday: "10:00 à 00:00",
      },
      gallery: {
        gallery_0: "Galerie 0",
        image_1: "1",
        image_2: "2",
        image_3: "3",
        image_4: "4",
        image_5: "5",
        baked_potato_2: "Pomme de terre au four 2",
        chicken_stroganoff_1: "Poulet stroganoff 1",
      },
      contact: {
        phone_1: "09999903535",
        phone_2: "02191017077",
        phone_3: "90007425",
        company_number: "02191017077",
        email: "info@qrland.ir",
        fax: "02191016066",
        location:
          "Téhéran, rue Shariati, après le pont Seyed Khandan, impasse Khandan, n° 6, unité 3",
        codePostal: "1541946815",
        website: "www.terminalads.com",
        address_details:
          "Iran, Téhéran, ville de Téhéran, Téhéran, district 3 de la ville de Téhéran, quartier Seyed Khandan, Dr Ali Shariati, Khandan",
      },
    },
    messages: {
      qr_created_success: "Menu en ligne créé avec succès.",
      qr_updated_success:
        "Votre QR de menu en ligne a été modifié avec succès.",
      qr_create_error: "Erreur lors de la création du QR !",
      qr_update_error: "Erreur lors de la sauvegarde/modification du QR",
      template_categories_saved:
        "Les catégories du modèle d'exemple ont été enregistrées avec succès.",
      template_products_saved:
        "Les produits du modèle d'exemple ont été enregistrés avec succès.",
      template_categories_error:
        "Erreur lors de l'enregistrement des catégories du modèle d'exemple !",
      template_products_error:
        "Erreur lors de l'enregistrement des produits du modèle d'exemple !",
    },
    sample_menu: "Menu d'exemple",
    view_qr: "Voir le QR",
    preview: "Aperçu",
    download_qr: "Télécharger le QR",
    create_qr: "Créer un QR",
    online_menu_name: "Nom du menu en ligne",
    online_menu_name_short: "Nom du menu",
    enter_qr_address: "Entrez l'adresse QR",
    qr_address: "Adresse QR",
    enter_menu_information: "Entrez les informations du menu",
    cleardefaults: "Effacer les valeurs par défaut",
    select_sample_menu: "Sélectionner un menu d'exemple",
    select_ready_menu: "Sélectionner un menu prêt",
    online_sales: "Ventes en ligne",
    sales_settings: "Paramètres de vente",
    download: "Télécharger",
    gallery_photos: "Photos de la galerie",
    fast_food_1: "Image de fast-food 1",
    fast_food_2: "Image de fast-food 2",
    large_chain_fast_food: "Grande chaîne de fast-food",
    best_fast_food_taste_experience:
      "Découvrez le meilleur goût de fast-food avec nous",
    online_menu_created_successfully: "Menu en ligne créé avec succès.",
    qr_creation_failed: "Erreur lors de la création du QR !",
    online_menu_qr_updated_successfully:
      "Votre QR de menu en ligne a été modifié avec succès.",
    error_saving_updating_qr: "Erreur lors de la sauvegarde/modification du QR",
    sample_model_categories_saved_successfully:
      "Les catégories du modèle d'exemple ont été enregistrées avec succès.",
    sample_model_products_saved_successfully:
      "Les produits du modèle d'exemple ont été enregistrés avec succès.",
    error_saving_sample_model_products:
      "Erreur lors de l'enregistrement des produits du modèle d'exemple !",
    error_saving_sample_model_categories:
      "Erreur lors de l'enregistrement des catégories du modèle d'exemple !",
  },
  editMenu: {
    enter_menu_information: "Entrez les informations du menu",
    online_menu_name: "Nom du menu en ligne",
    online_menu_name_short: "Nom court du menu en ligne",
    fields: {
      qr_address_hint: "Adresse QR pour accéder au menu en ligne",
    },
    online_sales: "Ventes en ligne",
    sales_settings: "Paramètres de vente",
    shop: {
      upload_banner: "Télécharger la bannière",
      create_product: "Créer un produit",
      user_info: "Informations utilisateur",
      add_social_media: "Ajouter les réseaux sociaux",
      photo_gallery: "Galerie photo",
      video_gallery: "Galerie vidéo",
      feedback: "Retour d'expérience",
      working_hours: "Heures d'ouverture",
    },
    success_message: "Votre carte de visite a été modifiée avec succès.",
  },
  qrCodeSquare: {
    dots_color: "Couleur des points",
    gradient_color: "Couleur en dégradé",
    linear: "Linéaire",
    radial: "Radial",
    color_rotation: "Rotation de couleur",
    first_color: "Première couleur",
    second_color: "Deuxième couleur",
    dots_color_label: "Couleur des points",
  },
  language: {
    selectAll: "Tout sélectionner",
    lang: {
      fa: "Persan",
      ar: "Arabe",
      ar_ae: "Arabe (EAU)",
      ar_iq: "Arabe (Irak)",
      en_US: "Anglais (USA)",
      en_GB: "Anglais (RU)",
      de: "Allemand",
      fr: "Français",
      zh_CN: "Chinois simplifié",
      zh_TW: "Chinois traditionnel",
      tr: "Turc",
      ru: "Russe",
      hy: "Arménien",
    },
    only_manual_now:
      "Seule la traduction manuelle est disponible pour le moment",
    ai_coming_soon: "La traduction IA sera activée bientôt",
    got_it: "Compris",
    origin_language: "Langue source",
    target_languages: "Langues cibles",
    remove_all: "Supprimer toutes les langues",
    translation_method: "Choisir la méthode de traduction",
    manual_translation: "Traduction manuelle",
    ai_translation: "Traduction IA",
    coming_soon: "Bientôt disponible",
    source_language_updated: "Langue source mise à jour",
    error_changing_source_language:
      "Erreur lors du changement de langue source",
    source_language_created: "Nouvelle langue source créée",
    languages_saved: "Nouvelles langues enregistrées",
    error_saving_languages: "Erreur lors de l'enregistrement des langues",
    error_loading_language: "Erreur de chargement de la langue",
    languages_removed: "Langues supprimées",
    new_languages_to_save: "Nouvelles langues à enregistrer",
    saved: "Enregistré",
    management_langs: "Gestion des langues",
    add_langs: "Ajouter une langue",
    change_language: "Changer de langue",
    visit_card: "Carte de visite",
    translate_to: "Traduire vers",
    main_language: "Langue",
    no_languages_available: "Aucune langue disponible",
    return_to_default: "Retour à la langue par défaut",
    translate: "Traduire",
    changes_pending: "En attente de l'application des modifications",
    apply_changes: "Appliquer les modifications",
    cancel_changes: "Annuler",
  },
  winner_list: "Liste des gagnants",
  qrwinnersList: {
    winnerstotalcount: "Nombre total de gagnants pour le QR",
    winnerscountoffilter: "Nombre de gagnants avec le filtre appliqué",
    winnersList: "Liste des gagnants QR",
    prize: "Prix",
    winnerName: "Nom du gagnant",
    date: "Date",
    noWinners: "Aucun gagnant",
    perPage: "Éléments par page",
    search: "Rechercher par nom ou prix",
    sortDirection: "Sens du tri",
    sortBy: "Trier par",
  },
  appearance_settings: "Paramètres d'apparence",
  header_color: "Couleur de l'en-tête",
  background_color: "Couleur de fond",
  text_color: "Couleur du texte",
  font_size: "Taille de la police",
  chat_logo: "Logo du chat",
  floating_button_icon: "Icône du bouton flottant",
  assistant_name: "Nom de l'assistant",
  chat_preview: "Aperçu du chat",
  smart_assistant: "Assistant intelligent",
  online: "En ligne",
  aiChatSettings: {
    select_assistant: "Sélectionner l'assistant",
    appearance_settings: "Paramètres d'apparence",
    lead_connection_tab: "Capture de leads - Connexion au club clients",

    header_settings: "Paramètres d'en-tête",
    header_settings_desc: "Couleur et style de l'en-tête du chat",
    text_settings: "Paramètres de texte",
    text_settings_desc: "Couleur et taille de police",
    logo_settings: "Paramètres du logo",
    logo_settings_desc: "Photo ou icône de l'assistant",
    background_settings: "Paramètres d'arrière-plan",
    background_settings_desc: "Image ou couleur d'arrière-plan",

    gradient_color: "Couleur en dégradé",
    solid_color: "Couleur unie",
    use_image: "Utiliser une image",
    use_icon: "Utiliser une icône",

    first_color: "Première couleur",
    second_color: "Deuxième couleur",
    header_color: "Couleur d'en-tête",
    text_color: "Couleur du texte",
    background_color: "Couleur d'arrière-plan",

    font_size: "Taille de police",

    robot: "Robot",
    chat: "Discussion",
    support: "Support",
    question: "Question",
    message: "Message",
    assistant_voice: "Assistant vocal",
    ai_brain: "Intelligence artificielle",

    lead_connection_title: "Connexion au club clients",
    lead_alert:
      "Ces paramètres permettront d'enregistrer les informations dans le club clients lorsque l'utilisateur choisit de soumettre un lead.",

    hasAssistantsName_label: "Capturer le prénom",
    hasAssistantsName_hint: "Demander le prénom de l'utilisateur",
    hasAssistantsFamily_label: "Capturer le nom de famille",
    hasAssistantsFamily_hint: "Demander le nom de famille de l'utilisateur",
    hasAssistantsMobile_label: "Capturer le numéro mobile",
    hasAssistantsMobile_hint: "Demander le numéro mobile de l'utilisateur",
  },
  assistantChatViewer: {
    assistant_name: "Assistant intelligent",
    online: "En ligne",
    new_chat: "Nouvelle discussion",
    clear_chat: "Effacer la discussion",
    close: "Fermer",
    message_placeholder: "Message...",
    processing: "Traitement en cours...",
    renew: "Renouveler",
    created_at: "Créé le",
    last_edit: "Dernière modification",
    copied: "Copié",
    copy: "Copier",
    print_qr: "Imprimer le QR",
    print_visit_card: "Imprimer la carte de visite",
    send_link: "Envoyer le lien",
    winner_list: "Liste des gagnants",
    customer_list: "Liste des clients",
    order_list: "Liste des commandes",
    reserved_appointments: "Rendez-vous réservés",
    feedback: "Retour",
    request_form: "Formulaire de demande",
    transfer_ownership: "Transférer la propriété",
    store_management: "Gestion du magasin",
    select_nfc_card: "Sélectionner la carte NFC",
    edit: "Modifier",
    design: "Design",
    qr_settings: "Paramètres QR",
    deactivate: "Désactiver",
    download: "Télécharger",
    viewed: "Vu",
    see_more: "Voir plus",
    updating_qr: "Mise à jour du QR...",
  },
  create_game: "Créer un jeu",
  ready_games: "Jeux prêts",
  add_game: "Ajouter un jeu",
  game_gallery: "Galerie de jeux",
  game_size_error: "La taille du fichier du jeu ne doit pas dépasser 2 Mo",
  game_upload_error: "Erreur lors du téléchargement du jeu",
  no_game_available: "Aucun jeu disponible",
  to_use_ready_games_search_category_or_product:
    "Pour utiliser des jeux prêts, recherchez par catégorie ou produit",
  gif_size_error: "La taille du fichier GIF ne doit pas dépasser 2 Mo",
  previewer_page: "Affichage de l'aperçu",
  // ─────────────────────────────────────────────────────
  // Clés de traduction pour la section jeu, GIF et paramètres
  // Fichier : src/core/services/langs/fr.js
  // Langue : Français (standard, adapté aux interfaces de jeux vidéo)
  // ─────────────────────────────────────────────────────
  // 1. Éditeur principal de jeu (PublicGameEditor)
  game_editor: "Éditeur de jeu",
  reset_defaults: "Réinitialiser aux valeurs par défaut",
  save_and_preview: "Enregistrer et prévisualiser",
  texts: "Textes",
  images: "Images",
  colors: "Couleurs",
  general_settings: "Paramètres généraux",
  gameplay_settings: "Paramètres de gameplay",
  effects: "Effets",
  login_and_phone: "Connexion et numéro de téléphone",
  no_settings_available_for_this_game_type:
    "Aucun paramètre disponible pour ce type de jeu",
  confirm_reset: "Confirmer la réinitialisation",
  reset_all_settings_to_default:
    "Êtes-vous sûr de vouloir réinitialiser tous les paramètres aux valeurs par défaut ?",
  yes_reset: "Oui, réinitialiser",
  cancel: "Annuler",
  settings_reset_successfully: "Paramètres réinitialisés avec succès",
  saved_and_ready_for_preview: "Enregistré et prêt pour la prévisualisation",

  // 2. Onglet Connexion & Téléphone (TabLogin)
  login_and_phone_settings: "Paramètres de connexion et numéro de téléphone",
  ask_phone_after_game: "Demander le numéro de téléphone après la partie",
  phone_prompt_text: "Texte de demande de numéro de téléphone",
  phone_prompt_hint:
    "Texte affiché dans la boîte de dialogue de demande de numéro",
  submit_button: "Bouton Soumettre",
  login_dialog_logo: "Logo de la boîte de dialogue de connexion",
  logo_url: "URL du logo",

  // 3. Onglet Effets (TabEffect)
  game_effects_settings: "Paramètres des effets du jeu",
  sound_enabled: "Activer le son",
  volume: "Volume",
  volume_hint: "Niveau de volume du jeu (de 0 à 1)",
  oscillator_type: "Type d'oscillateur",
  jump_sound_freq: "Fréquence du son de saut",
  hit_sound_freq: "Fréquence du son de collision",
  powerup_sound_freq: "Fréquence du son de power-up",
  move_sound_freq: "Fréquence du son de déplacement",
  combo_base_freq: "Fréquence de base du combo",
  sound_durations: "Durées des sons",
  move_duration_ms: "Durée du son de déplacement (ms)",
  jump_duration_ms: "Durée du son de saut (ms)",
  combo_duration_ms: "Durée du son de combo (ms)",
  hit_duration_ms: "Durée du son de collision (ms)",
  vibration_enabled: "Activer la vibration",
  particles_enabled: "Activer les particules",
  explosion_settings: "Paramètres d'explosion de particules",
  particle_count: "Nombre de particules",
  gravity: "Gravité",
  friction: "Friction",
  fade_speed: "Vitesse de fondu",

  // 4. Onglet Images (TabImages)
  game_images_and_assets: "Images et assets du jeu",
  player_image: "Image du joueur",
  player: "Joueur",
  powerup_image: "Image du power-up",
  qr_powerup: "Power-up QR",
  enemy_images: "Images des ennemis",
  optional_multi: "Optionnel, plusieurs images",
  enemies: "Ennemis",
  background_image: "Image de fond",
  background: "Fond",
  phone_frame_background: "Fond du cadre téléphone",
  phone_frame: "Cadre téléphone",
  winner_background: "Fond du gagnant",
  winner: "Gagnant",
  ground_image: "Image du sol",
  ground: "Sol",
  player_character: "Personnage du joueur",
  far_background_layer: "Couche de fond lointain",
  background_far: "Fond lointain",
  near_background_layer: "Couche de fond proche",
  background_near: "Fond proche",
  obstacle_images: "Images des obstacles",
  multi_optional: "Plusieurs images, optionnel",
  obstacles: "Obstacles",

  // 5. Onglet Textes (TabTexts)
  game_text_contents: "Contenu textuel du jeu",
  main_screen_texts: "Textes de l'écran principal",
  game_title: "Titre du jeu",
  game_subtitle: "Sous-titre du jeu",
  start_button: "Bouton Démarrer",
  score_label: "Étiquette Score",
  game_over_screen: "Écran Game Over",
  game_over_title: "Titre Game Over",
  game_over_subtitle: "Sous-titre Game Over",
  phone_prompt: "Demande de numéro de téléphone",
  restart_button: "Bouton Recommencer",
  hud_and_labels: "HUD et étiquettes",
  level_label: "Étiquette Niveau",
  combo_label: "Étiquette Combo",
  final_score_label: "Étiquette Score final",
  high_score_label: "Étiquette Meilleur score",
  messages_and_popups: "Messages et popups",
  new_record_message: "Message Nouveau record",
  fun_random_messages: "Messages aléatoires amusants",
  add_new_message: "Ajouter un nouveau message",

  // 6. Onglet Paramètres généraux (TabSetting)
  general_game_settings: "Paramètres généraux du jeu",
  enemy_spawn_rate: "Taux d'apparition des ennemis",
  frames_between_enemies_spawn: "Images entre apparitions d'ennemis",
  powerup_spawn_rate: "Taux d'apparition des power-ups",
  frames_between_qr_spawn: "Images entre apparitions QR",
  win_score_threshold: "Seuil de score pour gagner",
  score_required_for_win_or_phone_prompt:
    "Score requis pour victoire ou demande de téléphone",
  starting_lives: "Vies initiales",
  high_score_storage_key: "Clé de stockage du meilleur score",
  phone_prompt_score_threshold: "Seuil de score pour demande de téléphone",
  score_to_show_phone_number_form:
    "Score pour afficher le formulaire de numéro de téléphone",
  no_general_settings_available_for_this_game:
    "Aucun paramètre général disponible pour ce jeu",

  // 7. Onglet Gameplay (TabGamePlay)
  speed_settings: "Paramètres de vitesse",
  initial_speed: "Vitesse initiale",
  max_speed: "Vitesse maximale",
  speed_increase_every_frames: "Augmenter la vitesse tous les X images",
  speed_increase_amount: "Montant d'augmentation de vitesse",
  distance_per_level: "Distance par niveau",
  level_speed_increase: "Augmentation de vitesse par niveau",
  jump_and_physics: "Saut et physique",
  jump_force: "Force de saut",
  max_jump_height: "Hauteur maximale de saut",
  lanes_settings: "Paramètres des voies",
  number_of_lanes: "Nombre de voies",
  starting_lane: "Voie de départ",
  enemies_spawn: "Apparition des ennemis",
  traps_spawn: "Apparition des pièges",
  min_spawn_interval_ms: "Intervalle minimal d'apparition (ms)",
  max_spawn_interval_ms: "Intervalle maximal d'apparition (ms)",
  same_lane_chance: "Probabilité même voie",
  probability_of_spawn_in_player_lane:
    "Probabilité d'apparition dans la voie du joueur",
  collision_tolerance_px: "Tolérance de collision (px)",
  scoring_rules: "Règles de score",
  hit_penalty: "Pénalité de collision",
  powerup_reward: "Récompense power-up",
  score_speed_divider: "Diviseur score/vitesse",
  reset_combo_on_hit: "Réinitialiser combo sur collision",
  camera_settings: "Paramètres de caméra",
  normal_zoom: "Zoom normal",
  hit_zoom: "Zoom sur collision",
  zoom_lerp_speed: "Vitesse d'interpolation du zoom",
  game_end_conditions: "Conditions de fin de partie",
  phone_dialog_score_threshold: "Seuil de score pour dialogue téléphone",

  // 8. Onglet Couleurs (TabColors)
  background_gradient: "Dégradé de fond",
  first_color: "Première couleur",
  second_color: "Deuxième couleur",
  particle_hit_color: "Couleur particules collision",
  particle_powerup_color: "Couleur particules power-up",
  main_background_color: "Couleur de fond principale",
  ground_color: "Couleur du sol",
  hud_colors: "Couleurs HUD",
  hud_background: "Fond HUD",
  score_text_color: "Couleur texte score",
  level_text_color: "Couleur texte niveau",
  combo_text_color: "Couleur texte combo",
  overlay_colors: "Couleurs overlay",
  backdrop_color: "Couleur de fond overlay",
  card_background: "Fond de carte",
  card_border_color: "Couleur bordure carte",
  explosion_particle_color: "Couleur particules explosion",

  // 9. Composant de prévisualisation QR (previewerQr)
  gif_tab: "Onglet GIF",
  game_tab: "Onglet Jeu",
  welcome_gif_upload: "Télécharger GIF de bienvenue",
  default_welcome: "Bienvenue par défaut",
  loading_animation: "Animation de chargement",
  hide_previewer: "Masquer la prévisualisation",
  show_previewer: "Afficher la prévisualisation",
  edit_game_settings: "Modifier les paramètres du jeu",
  save_and_close: "Enregistrer et fermer",
  animation_scale: "Échelle de l'animation",
  animation_slide_x: "Animation glissement horizontal",
  animation_slide_y: "Animation glissement vertical",
  animation_fade: "Animation fondu",
  game_settings_saved: "Paramètres du jeu enregistrés",
  no_game_configured: "Aucun jeu configuré",

  // 10. Sélecteur GIF (gifSelector)
  gallery_name: "Nom de la galerie",
  change_gallery_name: "Changer le nom de la galerie",
  add_gif: "Ajouter GIF",
  select_gif: "Sélectionner GIF",
  show_gif: "Afficher GIF",
  selected_gif: "GIF sélectionné",
  count: "Nombre",
  select_category: "Sélectionner catégorie",
  after_typing_enter: "Après saisie, appuyer sur Entrée",
  search: "Rechercher",
  no_gif_available: "Aucun GIF disponible",
  to_use_ready_gifs_search_category_or_product:
    "Pour utiliser des GIF prêts, rechercher par catégorie ou produit",
  max_file_size_2mb: "Taille maximale du fichier : 2 Mo",
  upload_file: "Télécharger fichier",
  drag_and_drop_to_upload_or: "Glisser-déposer pour téléverser ou",
  here: "ici",
  click: "cliquer",
  all: "Tous",
  no_gif_found: "Aucun GIF trouvé",
  for_adding_file_use_upload_center:
    "Pour ajouter un fichier, utiliser le centre de téléversement",
  to_use_external_gif_link_fill_fields:
    "Pour utiliser un lien GIF externe, remplir les champs",
  gif_url_hint: "URL complète du fichier GIF",
  gif_url: "URL GIF",
  add: "Ajouter",
  title: "Titre",
  link: "Lien",
  description: "Description",
  add_new_gallery: "Ajouter nouvelle galerie",
  enter_valid_link: "Entrer un lien valide",
  create_gif: "Créer GIF",
  ready_gifs: "GIF prêts",
  gif_gallery: "Galerie GIF",
  edit_gif: "Modifier GIF",
  max_background_gif_size_2mb: "Taille maximale GIF de fond : 2 Mo",
  uploaded_successfully: "Téléversé avec succès",
  gif_upload_error: "Erreur lors du téléversement GIF",

  // 11. Textes supplémentaires et clés de test
  preview: "Aperçu",
  start_button_text: "Texte du bouton Démarrer",
  game_over_text: "Texte Game Over",
  game_over_subtext: "Sous-texte Game Over",
  mobile_prompt_text: "Texte de demande mobile",
  submit_button_text: "Texte du bouton Soumettre",
  optional: "Optionnel",
  game_background: "Fond du jeu",
  background_gradient_colors: "Couleurs du dégradé de fond",
  frames_per_enemy: "Images par ennemi",
  frames_per_powerup: "Images par power-up",
  win_threshold: "Seuil de victoire",
  score_to_win: "Score pour gagner",
  your_work_page_name: "Kiwvar personnel/entreprise",
  "pdf_gallery": {
    "display_mode": "Mode d'affichage de la galerie PDF",
    "display_mode_label": "Mode d'affichage",
    "layout": {
      "list": "Vue en liste",
      "accordion": "Vue en accordéon",
      "slider": "Vue en diaporama"
    },
    "gallery_name": "Nom de la galerie",
    "selected_gallery": "Galerie sélectionnée",
    "add_file": "Ajouter un fichier",
    "pdf_gallery_label": "Galerie PDF",
    "select_file": "Sélectionner un fichier",
    "title": "Titre",
    "pdf_url": "URL du PDF",
    "description": "Description",
    "add_button": "Ajouter",
    "all": "Tout",
    "image_gallery": "Galerie d'images",
    "edit_pdf": "Modifier le PDF",
    "preview": "Aperçu",
    "add_pdf_gallery": "Ajouter une galerie PDF",
    "default_gallery_name": "Galerie",
    "gallery_prefix": "Galerie",
    "tabs": {
      "add_file": "Ajouter un fichier",
      "pdf_gallery": "Galerie PDF",
      "link": "Lien"
    },
    "messages": {
      "file_too_large": "La taille du fichier ne peut pas dépasser 10 Mo.",
      "invalid_file_type": "Veuillez sélectionner uniquement des fichiers de documents et de texte.",
      "upload_error": "Erreur lors du téléchargement du fichier.",
      "only_pdf_txt_allowed": "Seuls les fichiers PDF et TXT peuvent être ajoutés.",
      "title_url_required": "Veuillez entrer le titre et l'URL du fichier."
    }
  },
  "special_info_desc": {
    "textCards": "Ajoutez des cartes de texte pour afficher des informations utilisateur telles que des descriptions ou une courte biographie.",
    "customerClubSettings": "Définissez le message d'adhésion au club client envoyé aux utilisateurs après l'enregistrement de leur numéro.",
    "advanceSettings": "Gérez les paramètres avancés et intelligents pour personnaliser le comportement de la page.",
    "voiceGallery": "Téléchargez et gérez des fichiers audio à lire sur la page.",
    "VideoGallery": "Ajoutez et affichez des vidéos pour la présentation, la formation ou le contenu.",
    "imageUploader": "Téléchargez des images à afficher dans la galerie ou dans différentes parties de la page.",
    "colorPallete": "Sélectionnez des couleurs personnalisées pour le design de la page.",
    "socialMediaIcons": "Ajoutez des liens vers les réseaux sociaux pour un accès rapide des utilisateurs.",
    "pdfSelector": "Téléchargez et affichez des fichiers PDF pour que les utilisateurs puissent les voir ou les télécharger.",
    "FeedBack": "Recevez les commentaires et avis des utilisateurs sur les services ou le contenu.",
    "consultationNew": "Créez un formulaire pour que les utilisateurs puissent soumettre des demandes ou vous contacter."
  },
  "voice_gallery": {
    "autoplay_warning": "Vous ne pouvez définir qu'un seul fichier audio en lecture automatique à la fois.",
    "autoplay": "Lecture automatique"
  },
  "card": {
    "consultation": {
      "title": "Formulaire de demande"
    },
    "form": {
      "name": "Prénom",
      "surname": "Nom de famille",
      "phone": "Numéro de mobile",
      "email": "E-mail",
      "address": "Adresse",
      "national_id": "Numéro national",
      "location": "Emplacement",
      "description": "Description"
    },
    "feedback": {
      "title": "Vos commentaires",
      "description": "Veuillez nous aider à améliorer nos services en répondant aux questions suivantes :",
      "q1": "Êtes-vous satisfait des services de QRLand ?",
      "q2": "Dans quelle mesure les services de QRLand ont-ils répondu à vos besoins ?",
      "q3": "Dans quelle mesure le coût payé pour le service reçu était-il raisonnable ?",
      "q4": "Partagez vos réflexions avec nous pour améliorer nos services."
    },
    "pdf": {
      "gallery_name": "Galerie de propositions QRLand",
      "item1_title": "Proposition de présentation de produit",
      "item1_desc": "Présentation complète des services QRLand, du fonctionnement des codes QR intelligents et des avantages pour les entreprises.",
      "item2_title": "Proposition de carte de visite numérique",
      "item2_desc": "Présentation de la carte de visite numérique QRLand, partage rapide des informations de contact et liens sociaux."
    },
    "pdf_selector": {
      "title": "Galerie PDF",
      "description": "Description"
    },
    "info": {
      "visit_name": "QRLand / Carte de visite numérique",
      "organization_name": "QRLand",
      "sub_organ": "La première plate-forme de génération de QR dynamiques",
      "user_name": "Carte de visite numérique",
      "fax": "Fax : 02191016066",
      "location_desc": "N° 6, ruelle Khandan, après le pont Seyed Khandan, rue Shariati, Téhéran",
      "postal_code": "Code postal : 1541946815",
      "about_us": "En raison des problèmes liés aux cartes de visite physiques, QRLand a introduit la 'Carte de visite numérique', éliminant complètement leurs limites et empêchant l'abattage excessif d'arbres.",
      "full_address": "Iran, Province de Téhéran, Téhéran, District 3, quartier Seyed Khandan, Dr. Ali Shariati, Khandan"
    },
    "extra": {
      "field1": "🟥 Créez une carte de visite numérique similaire pour votre entreprise.\n🟧 Testez-la gratuitement pendant 3 jours.\n🟨 Cliquez ici pour vous inscrire gratuitement.",
      "field2": "Votre carte de visite numérique comporte un code QR dynamique. Vous pouvez modifier les informations à tout moment. Votre code ne changera jamais.",
      "field3": "💲 Le coût de cette carte de visite est de 900 000 Tomans."
    },
    "gallery": {
      "name": "Nous serons toujours à vos côtés..."
    },
    "social": {
      "address_hint": "Veuillez entrer votre adresse",
      "address_label": "Adresse",
      "instagram_hint": "Veuillez entrer votre URL Instagram",
      "instagram_label": "Instagram",
      "whatsapp_hint": "Veuillez entrer votre URL WhatsApp",
      "whatsapp_label": "WhatsApp"
    },
    "video": {
      "item1_name": "Pourquoi la carte QRLand ? Qu'est-ce qui différencie QRLand ?",
      "item1_title": "Pourquoi la carte de visite QRLand",
      "item2_name": "Présentation de la carte de visite numérique QRLand",
      "item2_title": "La meilleure alternative aux cartes physiques"
    },
    "club": {
      "title": "Adhésion au club client",
      "description": "Ce n'est pas un club client ordinaire !\nEnregistrez votre numéro"
    },
    "audio": {
      "category_all": "Tout",
      "item1_title": "Guide complet des cartes de visite numériques",
      "diff_seconds": "il y a 1 seconde"
    }
  },
  "pic": {
    "background_image": "Image d'arrière-plan",
    "image_display_type": "Type d'affichage de l'image",
    "image_orientation": "Orientation de l'image :",
    "horizontal": "Horizontal",
    "vertical": "Vertical",
    "change_display_mode": "Changer le mode d'affichage",
    "image": "Image",
    "uploaded_image": "Image téléchargée"
  },
   "send_limit_per_user": "Limite d'envoi par utilisateur (0 = illimité)",
    "enable_discount_code": "Activer le code de réduction",
    "add_new_discount_code": "Ajouter un nouveau code de réduction",
    "no_discount_codes_added": "Aucun code de réduction ajouté",
"toolsManagment": "Outils de gestion",
"gateway": {
  "edit": "Modifier",
  "integrated_edit_all_sections": "Modification intégrée de toutes les sections",
  "show_descriptions": "Afficher les descriptions",
  "search_section_placeholder": "Rechercher une section...",
  "no_section_found": "Aucune section trouvée avec ce nom.",
  "back_to_menu": "Retour au menu",
  "cancel": "Annuler",
  "save": "Enregistrer"
},
"gridShow": "Affichage en grille",
"tableShow": "Affichage en tableau",
"editvisit": {
  special_info_single: {
    text_cards_description:
      "Ajoutez des cartes de texte pour afficher des informations sur l'utilisateur, telles que des descriptions, des expériences ou une courte présentation.",

    customer_club_settings_description:
      "Configurez le message d'adhésion au club client envoyé aux utilisateurs après l'enregistrement de leur numéro de téléphone.",

    advance_settings_description:
      "Gérez les paramètres avancés et intelligents pour personnaliser le comportement et les fonctionnalités de la page.",

    voice_gallery_description:
      "Téléchargez et gérez les fichiers audio à lire sur la page.",

    video_gallery_description:
      "Ajoutez et affichez des vidéos pour la présentation, la formation ou la diffusion de contenu.",

    image_uploader_description:
      "Téléchargez des images à afficher dans la galerie ou dans différentes sections de la page.",

    color_palette_description:
      "Choisissez des couleurs personnalisées pour personnaliser l'apparence et le design de la page.",

    social_media_icons_description:
      "Ajoutez des liens vers les réseaux sociaux pour un accès rapide.",
  },
},

"editBpage": {
  special_info_single: {
    banner_selector_description:
      "Téléchargez ou modifiez l'image de la bannière principale du complexe.",

    logo_select_description:
      "Définissez le logo de l'entreprise ou du complexe.",

    service_description:
      "Gérez les principaux services et équipements du complexe.",

    faq_description:
      "Ajoutez et modifiez les questions fréquemment posées par les clients.",

    blog_description:
      "Ajoutez des articles et des actualités concernant le complexe.",

    floor_description:
      "Gérez les étages et les unités commerciales du complexe.",

    text_cards_description:
      "Saisissez les descriptions et les informations relatives à l'utilisateur.",

    social_media_icons_description:
      "Ajoutez des liens vers les réseaux sociaux pour communiquer avec les clients.",

    pic_selector_description:
      "Ajoutez des images du complexe et des magasins.",

    video_gallery_description:
      "Téléchargez des vidéos de présentation ou promotionnelles.",

    pdf_selector_description:
      "Gérez les catalogues et les fichiers d'information.",

    feedback_description:
      "Gérez la section des avis et retours des visiteurs.",

    consultation_new_description:
      "Gérez le formulaire de collecte des informations ou demandes des clients.",

    service_section_description:
      "Créez des sections dédiées aux services.",

    counter_service_description:
      "Affichez les statistiques et les réalisations du complexe sous forme numérique.",

    counter_description:
      "Configurez un compte à rebours pour les événements ou l'ouverture.",

    personnel_description:
      "Présentez les responsables et les membres clés de l'équipe.",

    customer_club_settings_description:
      "Gérez les paramètres SMS et l'inscription au club client.",

    work_sheet_description:
      "Définissez les horaires de travail et les jours d'activité du complexe.",

    pallet_commercial_description:
      "Configurez les couleurs et le style visuel de la page.",

    default_description:
      "Ajoutez et gérez la section {title} sur la page professionnelle.",
  },
},

store_special_info_single: {
  shop_login_config_description:
    "Configurez la page de connexion et modifiez le logo du magasin.",

  banner_selector_description:
    "Téléchargez et gérez les bannières du magasin.",

  text_cards_description:
    "Informations textuelles, présentation et à propos de nous.",

  product_description:
    "Créez, gérez et modifiez les produits.",

  special_category_manager_description:
    "Gérez les catégories des offres spéciales et des produits en promotion.",

  social_media_icons_description:
    "Ajoutez les liens vers les réseaux sociaux du magasin.",

  blog_description:
    "Rédigez et gérez les articles du blog.",

  service_description:
    "Présentez les services supplémentaires proposés.",

  faq_description:
    "Affichez et gérez la liste des questions fréquemment posées.",

  pic_selector_description:
    "Téléchargez et gérez la galerie d'images du magasin.",

  video_gallery_description:
    "Téléchargez des vidéos de présentation et promotionnelles.",

  pdf_selector_description:
    "Fournissez des fichiers d'aide ou des catalogues PDF.",

  feedback_description:
    "Gérez les avis et retours des clients.",

  counter_description:
    "Configurez un compte à rebours pour les événements ou promotions.",

  consultation_description:
    "Créez un formulaire pour recevoir des demandes ou des demandes de conseil.",

  service_section_description:
    "Gérez les sections dédiées aux services.",

  counter_service_description:
    "Affichez les statistiques, chiffres et réalisations du magasin.",

  personnel_description:
    "Présentez les membres de l'équipe et le personnel du magasin.",

  work_sheet_description:
    "Configurez les jours et horaires d'ouverture du magasin.",

  default_description:
    "Ajoutez et gérez la section {title} sur la page du magasin.",
},
edit_gold_special_info_single: {
  product_info_title: "Informations sur le produit",
  product_info_description:
    "Enregistrer et modifier les informations principales du produit, ses caractéristiques, son prix et ses descriptions complémentaires.",

  asset_management_title: "Gestion des ressources",
  asset_management_description:
    "Gérer les ressources, attribuer des valeurs et gérer les informations du portefeuille associées au produit.",

  add_social_networks_title: "Ajouter des réseaux sociaux",
  social_networks_title: "Réseaux sociaux",
  social_media_description:
    "Ajouter des liens vers les réseaux sociaux pour permettre aux clients de communiquer plus facilement avec votre marque.",

  add_video_title: "Ajouter une vidéo",
  video_description:
    "Ajouter et afficher des vidéos de présentation, de formation ou promotionnelles du produit.",

  add_image_title: "Ajouter une image",
  image_description:
    "Télécharger des images de haute qualité du produit sous différents angles pour une meilleure présentation dans la galerie.",

  select_color_title: "Choisir une couleur",
  color_palette_description:
    "Personnaliser la palette de couleurs et l'apparence de la page produit selon l'identité de votre marque.",
},

edit_multicard_special_info_single: {
  add_account_description:
    "Modifier le nom, la photo de profil et l'arrière-plan",

  management_account_description:
    "Ajouter et modifier les informations des comptes bancaires",

  management_color_description:
    "Modifier les couleurs des boutons et de l'arrière-plan",
},

edit_feedback_special_single: {
  base_info_description:
    "Modifier les informations de base et le titre du formulaire",

  image_uploader_description:
    "Télécharger et gérer le logo du formulaire de feedback",

  feedback_description:
    "Configurer les champs et gérer le formulaire de feedback",

  color_palette_description:
    "Choisir un thème de couleurs et personnaliser l'apparence du formulaire",
},

edit_gitf_special_info_single: {
  default_description:
    "Ajouter et gérer la section {title} dans le cadre QR des souvenirs.",
},

edit_catalog_special_info_single: {
  text_cards_description:
    "Informations de base, titre et description du catalogue",

  image_uploader_description:
    "Télécharger et gérer le logo ou l'image principale",

  pic_selector_description:
    "Télécharger et gérer les pages du catalogue ou de la brochure",

  social_media_icons_description:
    "Ajouter et gérer les liens vers les réseaux sociaux",

  color_palette_description:
    "Choisir un thème de couleurs et personnaliser l'apparence",
},

edit_menu_special_info_single: {
  theme_selector_description:
    "Sélectionner un modèle pour appliquer une catégorisation différente",

  login_config_description:
    "Paramètres et apparence de la page de connexion",

  general_settings_description:
    "Paramètres généraux de la devise et du type d'activité.",

  banner_selector_description:
    "Télécharger et sélectionner une image de bannière à afficher en haut de la page pour rendre le menu ou le profil plus attrayant.",

  product_description:
    "Créer et gérer des produits ou services avec des détails tels que l'image, le prix et la description personnalisée.",

  text_cards_description:
    "Ajouter des cartes de texte pour afficher les informations de base de l'utilisateur, comme une description générale, une expérience ou une courte présentation.",

  social_media_description:
    "Ajouter des liens et des icônes de réseaux sociaux pour faciliter la communication et l'accès des clients.",

  photo_gallery_description:
    "Créer une galerie d'images pour présenter des photos de produits, des réalisations ou l'environnement de l'entreprise.",

  video_gallery_description:
    "Ajouter une galerie vidéo pour afficher des publicités, des vidéos éducatives ou de présentation.",

  feedback_description:
    "Créer une section pour afficher les avis, retours et niveaux de satisfaction des clients précédents.",

  working_hours_description:
    "Définir les horaires de travail et les heures d'ouverture.",
},

edit_pdf_special_info_single: {
  base_info_title: "Informations",
  base_info_description:
    "Ajouter des cartes de texte pour afficher les informations de base de l'utilisateur, telles que les descriptions générales, les expériences ou une courte présentation.",

  image_uploader_title: "Télécharger le logo",
  image_uploader_description:
    "Télécharger et sélectionner une image comme logo ou photo de profil à afficher sur la page.",

  pdf_selector_title: "Ajouter une galerie PDF",
  pdf_selector_description:
    "Créer une galerie de fichiers PDF ou texte avec la possibilité d'ajouter une image de couverture et une description personnalisée pour chaque fichier.",

  social_media_icons_title: "Ajouter des réseaux sociaux",
  social_media_icons_description:
    "Ajouter des liens et des icônes de réseaux sociaux pour faciliter la communication et l'accès.",

  color_palette_title: "Choisir une couleur",
  color_palette_description:
    "Choisir la couleur du modèle et personnaliser l'apparence des éléments pour mieux correspondre à votre marque.",
},

edi_photogallery_spcial_info_single: {
  default_description:
    "Ajouter et gérer la section {title} dans la galerie photo.",
},

edi_social_special_info_single: {
  banner_selector_title: "Télécharger une photo",
  banner_selector_description:
    "Sélectionner et télécharger l'image d'arrière-plan ou la bannière en haut de votre page de réseau social.",

  base_info_title: "Informations",
  base_info_description:
    "Saisissez les informations de base telles que le titre principal et la description de votre profil.",

  image_uploader_title: "Télécharger le logo",
  image_uploader_description:
    "Téléchargez votre logo personnel ou de marque ou votre photo de profil pour l'afficher sur la page.",

  social_media_icons_title: "Ajouter des réseaux sociaux",
  social_media_icons_description:
    "Ajoutez des liens vers Instagram, Telegram, WhatsApp, LinkedIn et autres réseaux afin d'afficher leurs icônes sur la page.",
},

edit_text_special_info_single: {
  base_info_title: "Informations et textes QR",
  base_info_subtitle: "Texte principal et champs de texte",
  base_info_description:
    "Modifier le titre, le texte principal À propos de nous et les champs de texte QR personnalisés",

  image_uploader_title: "Logo et image d'arrière-plan",
  image_uploader_subtitle: "Paramètres de l'image",
  image_uploader_description:
    "Télécharger et modifier le logo personnalisé ou l'image d'arrière-plan de la carte",

  color_palette_subtitle: "Personnaliser l'apparence",
  color_palette_description:
    "Définir les couleurs de l'en-tête, de l'arrière-plan et du texte pour améliorer la lisibilité et le contraste",
},

edit_video_special_info_single: {
  base_info_title: "Informations",
  base_info_description:
    "Modifier les informations principales telles que le titre et l'adresse du QR code.",

  image_uploader_title: "Télécharger le logo",
  image_uploader_description:
    "Télécharger et gérer l'image du logo de la page.",

  video_gallery_title: "Galerie vidéo",
  video_gallery_description:
    "Ajouter, modifier et gérer les vidéos à afficher dans la galerie.",

  social_media_icons_title: "Ajouter des réseaux sociaux",
  social_media_icons_description:
    "Ajouter des liens vers les réseaux sociaux et des moyens de contact.",

  color_palette_title: "Choisir une couleur",
  color_palette_description:
    "Modifier les couleurs et choisir un thème adapté à la page.",
},

edit_product_special_info_single: {
  factory_info_description:
    "Modifier les informations et la présentation de l'entreprise",

  single_product_editor_description:
    "Modifier les informations principales et les boutons d'action tels que l'achat",

  customer_club_settings_description:
    "Paramètres du club client et envoi de SMS",

  advance_settings_description:
    "Paramètres avancés d'affichage et de sécurité",

  features_description:
    "Gérer les caractéristiques et spécifications techniques du produit",

  voice_gallery_description:
    "Télécharger et gérer les podcasts et fichiers audio",

  image_uploader_description:
    "Télécharger et gérer la galerie d'images du produit",

  video_gallery_description:
    "Ajouter et gérer la galerie vidéo associée",

  social_media_icons_description:
    "Ajouter et gérer les liens vers les réseaux sociaux",

  color_palette_description:
    "Choisir un thème de couleurs et personnaliser le modèle",
},

edit_product_pro_special_info_single: {
  factory_info_description:
    "Saisissez les informations générales et présentez l'entreprise de production.",

  single_product_editor_description:
    "Configurez les informations principales, le badge de confiance et le bouton d'achat du produit.",

  customer_club_settings_description:
    "Paramètres SMS et adhésion des clients au club.",

  features_description:
    "Ajoutez les caractéristiques et spécifications techniques du produit.",

  feedback_description:
    "Section des avis et retours des acheteurs.",

  consultation_description:
    "Formulaire de demande de conseil ou de commande.",

  advance_settings_description:
    "Paramètres avancés et intelligents d'affichage du produit.",

  voice_gallery_description:
    "Fichiers audio de présentation ou de guide du produit.",

  image_uploader_description:
    "Téléchargez différentes images du produit.",

  video_gallery_description:
    "Vidéos de présentation ou de formation liées au produit.",

  social_media_icons_description:
    "Liens vers les réseaux sociaux pour faciliter la communication.",

  color_palette_description:
    "Configurez les couleurs et le style visuel de la page produit.",
},

edit_voice_special_info_single: {
  base_info_voice_description:
    "Informations de base et détails de la galerie audio",

  image_uploader_description:
    "Télécharger et gérer le logo ou l'image de couverture",

  voice_gallery_description:
    "Télécharger et gérer les fichiers audio et podcasts",

  color_palette_description:
    "Choisir un thème de couleurs et personnaliser l'apparence de la galerie",
},

edit_voice_pro_special_info_single: {
  base_info_description:
    "Modifier le titre et la description de la galerie",

  image_uploader_description:
    "Télécharger et gérer le logo et la couverture principale",

  voice_gallery_acc_description:
    "Télécharger, supprimer et gérer les fichiers audio",

  social_media_icons_description:
    "Ajouter et gérer les liens vers les réseaux sociaux",

  color_palette_description:
    "Choisir un thème de couleurs et personnaliser l'apparence de la galerie",
},
edit_bpage_special_info_special: {
  advertising_sites: "Sites publicitaires",
stores: "Boutiques",

divar: "Divar",
divar_hint: "Entrez votre lien Divar",

sheypoor: "Sheypoor",
sheypoor_hint: "Entrez votre lien Sheypoor",

digikala: "Digikala",
digikala_hint: "Entrez votre lien Digikala",

basalam: "Basalam",
basalam_hint: "Entrez votre lien Basalam",

snappshop: "SnappShop",
snappshop_hint: "Entrez votre lien SnappShop",

technolife: "Technolife",
technolife_hint: "Entrez votre lien Technolife",

torob: "Torob",
torob_hint: "Entrez votre lien Torob",

emalls: "eMalls",
emalls_hint: "Entrez votre lien eMalls",

cafebazaar: "Cafe Bazaar",
cafebazaar_hint: "Entrez votre lien Cafe Bazaar",

googleplay: "Google Play",
googleplay_hint: "Entrez votre lien Google Play",

samsung: "Samsung",
samsung_hint: "Entrez votre lien Galaxy Store",

apple: "Apple",
apple_hint: "Entrez votre lien App Store",
  add_audio_gallery: "Ajouter une galerie de fichiers audio",
  factory_information: "Informations sur l’entreprise",
  trust_badge: "Badge de confiance",
  buy_button: "Bouton d’achat",
  smart_settings: "Paramètres intelligents",
  add_product_feature: "Ajouter une caractéristique au produit",
  product_features: "Caractéristiques du produit",
  add_audio_file: "Ajouter un fichier audio",
  audio_gallery: "Galerie audio",
  text: "Texte",
  logo_background: "Logo / arrière-plan",
  select_color: "Sélectionner une couleur",
  information: "Informations",
  luck_management: "Gestion de la chance",
  registration_management: "Gestion des inscriptions",
  turning: "Feuilletage",
  slider: "Curseur",
  vertical: "Vertical",
  upload_catalog_brochure_images: "Télécharger les images du catalogue / brochure",
  upload_banner: "Télécharger la bannière",
  upload_header_image: "Télécharger l’image d’en-tête",
  upload_image: "Télécharger une image",
  services: "Services",
  faq: "Questions fréquentes",
  blog: "Blog",
  create_product: "Créer un produit",
  user_information: "Informations utilisateur",
  add_social_media: "Ajouter les réseaux sociaux",
  photo_gallery: "Galerie photos",
  video_gallery: "Galerie vidéo",
  pdf_gallery: "Galerie PDF",
  feedback: "Commentaires",
  request_form: "Formulaire de demande",
  create_section: "Créer une section",
  achievements: "Réalisations",
  countdown: "Compte à rebours",
  team_members: "Membres de l’équipe",
  working_hours: "Horaires de travail",
  upload_logo: "Télécharger le logo",
  create_store: "Créer une boutique",
  customer_club_membership_sms: "SMS d’adhésion au club client",
  product_information: "Informations sur le produit",
  asset_management: "Gestion des ressources",
  social_media: "Réseaux sociaux",
  add_video: "Ajouter une vidéo",
  add_image: "Ajouter une image",
  add_user_information: "Ajouter les informations utilisateur",
  manage_accounts: "Gérer les comptes",
  manage_color: "Gérer les couleurs",
  download_qr: "Télécharger le code QR",
  add_store: "Ajouter une boutique",
  manage_appointments: "Gérer les rendez-vous",
},
edit_gift_special_info_special: 
{
  gift_story: "Histoire du cadeau",
  profile_image: "Photo de profil",
  featured_images: "Images à la une",
  image_gallery: "Galerie d’images",
  video_gallery: "Galerie vidéo",
  add_audio_file: "Ajouter un fichier audio",
  select_color: "Sélectionner une couleur",
},
edit_insurance_special_info_special: {
  login_settings: "Paramètres de connexion",
  shop_logo_images: "Logo et images de la boutique",
  login_page_information: "Informations de la page de connexion",
  upload_banner_logo: "Télécharger la bannière et le logo",
  user_information: "Informations utilisateur",
  manage_products_insurance: "Gérer les produits / assurances",
  special_sale: "Vente spéciale",
  add_social_media: "Ajouter les réseaux sociaux",
  blog: "Blog",
  services: "Services",
  faq: "Questions fréquentes",
  photo_gallery: "Galerie photos",
  video_gallery: "Galerie vidéo",
  pdf_gallery: "Galerie PDF",
  feedback: "Commentaires",
  countdown: "Compte à rebours",
  request_form: "Formulaire de demande",
  create_section: "Créer une section",
  achievements: "Réalisations",
  team_members: "Membres de l’équipe",
  working_hours: "Horaires de travail",
  shop_login_description: "Paramètres du logo et de la page de connexion de la boutique",
  insurance_manage_description: "Ajouter et modifier la liste des produits / services",
  banner_description: "Gérer les images d’en-tête",
},
};
